/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} / {b}',
  about: 'Hakkımızda',
  aboutThisItem: 'Bu Öge hakkında',
  accessApiKeyManager: 'Bu kiracı için Uygulama Programı Arabirimi Anahtarı Yöneticisi’ne erişin.',
  accessControls: 'Erişim Kontrolleri',
  accessControlsCopiedText: 'Erişim kontrolleri anında güncellenir. Medya güvenlik ayrıcalıkları birkaç dakika içinde güncellenecek.',
  accessControlsCopiedTitle: 'Erişim kontrolleri başarıyla kopyalandı',
  accessControlsCopyConfirmation: 'Bu, mevcut tüm erişim kontrollerini {to} üzerinden kaldıracak ve bunları {from} içindeki erişim kontrolleriyle değiştirecektir. Bu işlem geri alınamaz.',
  accessControlsDescription: 'Erişim kontrolleri, seçilen Kuruluşlara ve Medya Kategorilerine göre bu medyaları kimlerin görebileceğini tanımlar.',
  accessControlsHelpText: 'Bu Kuruluş için erişim kontrollerini yönetin. Kullanıcılar listelenen medyaya yalnızca her bir medyanın ait olduğu medya kategorilerini görüntüleme izinleri varsa erişebilir. Bir kuruluşa birden fazla medya uygulamak biraz zaman alabilir. Yapılan değişikliklerin geçerlilik kazanması için lütfen kısa bir süre bekleyin ve ardından sağlanan "Yenile" düğmesini kullanın.',
  accessControlsIndeterminance: 'Not: Ana kuruluşların, alt kuruluşlarından herhangi birine atanan içeriğe erişimi her zaman vardır.',
  accessControlsRefreshWarning: 'Kaydedilmemiş değişiklikleriniz var. Sayfanın yenilenmesi halinde bu değişiklikler kaybolacaktır. Devam etmek istiyor musunuz?',
  accessControlsSaveSuccess: 'Erişim Kontrolleri Başarıyla Kaydedildi.',
  accessControlsTitleSection: 'Bu kuruluşa erişim kontrolleri uygulandığında bu kontroller alt düzeyden üst düzeye yetki devri yoluyla aşağıdaki kuruluşlara da otomatik olarak atanır:',
  accessControlsTooltip: 'Kuruluşlar ayrıca alt kuruluşlarının erişebildiği içeriğe de erişebilirler. Aşağıdaki tabloda, bu kuruluşun örtük yukarı yönlü yetki devri veya alt düzeyden üst düzeye yetki devri yoluyla erişim sağladığı içerikler yer almamaktadır.',
  account: 'Hesap',
  accountErrorMessage: 'Hesap Hata Mesajı',
  accountErrorMessageWarning: 'Veri tabanındaki accountErrorMessage alanı, kiracı için “Yetkisiz” olarak ayarlanacaktır.',
  action: 'Aksiyon | Aksiyonlar',
  actionDelete: 'sil',
  actionLoad: 'yükle',
  actionPaste: 'Yapıştır',
  actionRun: 'çalıştır',
  actionSave: 'Kaydet',
  actionUndoWarning: 'Bu işlem geri alınamaz.',
  actionUpload: 'yükle',
  actualSize: 'Gerçek Boyut',
  add: 'Ekle',
  addABookText: 'Kitap ekle',
  addABookToStart: 'Başlamak için {addABookText}.',
  addAForm: 'Başlamak için bir Form ekleyin',
  addAFormOnly: 'Form Ekle',
  addAMedia: 'Medya ekle',
  addAPIKey: 'Uygulama Programı Arabirimi Anahtarı Ekleyin',
  addAPartCollection: 'Başlamak için bir {partCollection} ekleyin.',
  addAPrintSettingText: 'Yazdırma Ayarı Ekle',
  addAPrintSettingToStart: 'Başlamak için {addAPrintSettingText}.',
  addASharedCart: 'Paylaşılan sepet ekle',
  addATag: 'Etiket Ekle',
  addATemplate: 'Şablon ekle',
  addAllPartsCart: 'Tüm Parçaları Sepete Ekle',
  addAnOrderQuoteEmailFormat: 'Başlamak için Sipariş/Teklif',
  addBooks: 'Kitapları Ekle',
  addBrowseFlow: 'Göz Atma Akışı Ekle',
  addChapter: 'Bölüm Ekle',
  addChildBrowseFlow: 'Alt Kuruluş Göz Atma Akışı Ekle',
  addComment: 'Yorum ekle',
  addExistingPart: 'Mevcut Parça Ekle',
  addGroupsToUsers: '{users} kullanıcılarına {groups} grupları ekle',
  addItem: '{item} ekle',
  addMedia: 'Medya Ekle',
  addPages: 'Sayfa Ekle',
  addPart: 'Parça Ekle',
  addReports: 'Rapor Ekle',
  addRootBrowseFlow: 'Kök Göz Atma Akışı Ekle',
  addRow: 'Satır Ekle',
  addTemplates: 'Şablonları ekle',
  addToCartMessage: '{partNumber} bir başarılı şekilde eklendi',
  addToUserGroup: 'Gruplara Ekle',
  addWidgetKey: 'Bir Widget Anahtarı ekleyin',
  addedOn: 'Eklenme tarihi',
  additionalInformation: 'Ek Bilgi',
  additionalNotification: 'Ek Bildirim',
  additionalPartNumberDescription: 'Ek parça numarası alanı olarak kullan',
  address: 'Adres | Adresler',
  addressInUse: 'Bir adres şu anda varsayılan adres olarak ayarlı ve silinemiyor',
  addressInUseSubtitle: 'Bu adresi silmek için önce bu adresi varsayılan adres olarak silmelisiniz.',
  addressLine: 'Adres Hattı {number}',
  addressState: {
    confirmationMessage: 'Aşağıdaki adresler doğrulanmamış.',
    confirmationTitle: 'Doğrulanmamış adreslerle devam etmek istediğinizden emin misiniz?',
    disabledVerification: 'Sipariş/Teklif gönderimindeki kısım için adres doğrulaması devre dışı bırakılacak',
    enteredAddress: 'Girilmiş Adres',
    failedToFetchSuggestions: 'Adres önerileri alınamadı.',
    failedToLoadDetails: 'Adres ayrıntıları yüklenemedi.',
    incomplete: 'Eksik adres',
    missingSubpremise: 'Eksik adres alt birimi',
    noSuggestions: 'Hiçbir öneri bulunamadı. Lütfen öneriler için adresi düzenleyin.',
    selectAddress: '(lütfen bir seçenek seçin)',
    subpremiseMessage: 'Bu adres, bir daire veya ofis binasına ait gibi görünüyor. Adresi tamamlamak için lütfen bölüm, daire veya kapı numaranızı ekleyin.',
    suggested: 'Önerilen Adresler',
    unverified: 'Doğrulanmamış adres',
    unverifiedHelpText: 'Başka bir kayıtlı adres seçin veya bu adresi düzenleyin ya da yeni bir adres ekleyin',
    unverifiedMessage: 'Teslimat için bu adresi doğrulayamıyoruz.',
    verified: 'Doğrulanmış adres'
  },
  admin: 'Yönetici',
  adminCenter: 'Yönetici Merkezi',
  adminCenterBanner: {
    bodyLabel: 'Kapak Gövde Metni',
    enableLabel: 'Yönetici Kapağını Etkinleştir',
    headerGreenOption: 'Yeşil',
    headerLabel: 'Kapak Başlığı',
    headerRedOption: 'Kırmızı',
    headerYellowOption: 'Sarı',
    title: 'Yönetici Merkezi Kapağı',
    typeLabel: 'Kapak Türü'
  },
  adminCenterMessage: 'İçerik, kullanıcılar, kitaplık ayarları, raporlama ve dışa aktarma için yönetim merkezi',
  adminMessage: 'Kullanılabilen özellikler eklenir',
  administration: 'Yönetim',
  advancedFilters: 'Gelişmiş Filtreler',
  affectedBookMedia: '{count} Kitap Medyası güncellenecek.',
  affectedProductPages: '{count} Ürün Sayfası güncellenecek.',
  affectedTemplateMedia: '{count} Kitap Şablonu güncellenecek.',
  after: 'Sonra',
  aggregatedFromChildren: 'Alt Kuruluşlardan Toplanmış',
  aiAlgorithm: 'AI Tarayıcısı',
  algorithm: 'Algoritma',
  alignHorizontal: 'Yatay Hizala',
  alignVertical: 'Dikey Hizala',
  all: 'Tümü',
  allLibraryPages: 'Tüm Kütüphane Sayfaları',
  allPagesAndBooks: 'Tüm Sayfalar ve Kitaplar',
  allUsersDisabled: 'Kiracıya ait tüm kullanıcılar devre dışı bırakılacaktır.',
  alphanumeric: 'Alfasayısal',
  analyticsJSON: 'Analiz JSON‘u',
  andCountMore: 've {count} adet daha...',
  announcement: 'Duyuru | Duyurular',
  any: 'Herhangi Biri',
  apiAuthHeader: 'API Yetkilendirme Başlığı',
  apiKey: 'Uygulama Programı Arabirimi Anahtarı | Uygulama Programı Arabirimi Anahtarları',
  apiKeyAdmin: 'API Anahtarı Yöneticisi',
  apiKeyCopied: 'API Yetkilendirme Başlığı değeri Panoya kopyalandı',
  apiKeyDeleteMsg: 'Bu Uygulama Programı Arabirimi Anahtarının silinmesi entegrasyonlar tarafından kullanılmasını devre dışı bırakır',
  apiKeyDeleteTitle: 'Bu Uygulama Programı Arabirimi Anahtarını silmek istediğinize emin misiniz?',
  apiKeyDeleted: 'Uygulama Programı Arabirimi Anahtarı Silindi',
  apiKeyDeletedError: 'Uygulama Programı Arabirimi Anahtarı silinirken hata oluştu',
  apiKeyInstructions: 'Anahtar Kaydedildiğinde oluşturulacak',
  apiKeyManager: 'Uygulama Programı Arabirimi Anahtarı Yöneticisi',
  apiKeyNameEmpty: 'Ad boş olamaz',
  apiKeyRegenError: 'Uygulama Programı Arabirimi Anahtarı yeniden oluşturulurken hata oluştu',
  apiKeyRegenMsg: 'Bu Uygulama Programı Arabirimi Anahtarının yeniden oluşturulması mevcut entegrasyonları devre dışı bırakabilir.',
  apiKeyRegenTitle: 'Bu Uygulama Programı Arabirimi Anahtarını yeniden oluşturmak istediğinize emin misiniz?',
  apiKeySaved: 'Uygulama Programı Arabirimi Anahtarı Kaydedildi',
  apiKeyType: 'Uygulama Programı Arabirimi Anahtarı Türü',
  appliesTo: 'Geçerli',
  appliesToEmpty: 'En az bir varlık türünün seçilmesi gerekiyor',
  appliesToPopulated: 'Etiketin hangi varlıklara uygulanabileceğini ayarlayın',
  apply: 'Uygula',
  applyItem: '{item} uygula',
  applyToChildItems: 'Alt Kuruluş için Uygula {item}',
  applyToPartOnly: 'Yalnızca bu parçaya uygula',
  april: 'Nisan',
  areYouSure: '{item} ögesini silmek istediğinizden emin misiniz?',
  areYouSureCopy: '{item} ögesini kopyalamak istediğinizden emin misiniz?',
  areYouSureYouWantToDisableTheTenant: 'Kiracıyı devre dışı bırakmak istediğinizden emin misiniz?',
  area: 'Alan',
  assembly: 'Kurulum | Kurulumlar',
  assemblyConfirmationTitle: 'Kurulum oluşturmayı tamamlamak istiyor musunuz?',
  assemblyCreatorHelpText1: 'Bu özellik, seçilen bir sayfayı, bu parçanın {partName} bulunduğu her yerde kitaplara eklemenizi sağlar ve parçayı ve seçilen sayfayı bir hotpoint bağlantısı üzerinden otomatik olarak birbirine bağlar. İsteğe bağlı olarak, eklemeyi yalnızca seçili kitaplarla sınırlayabilirsiniz.',
  assemblyCreatorHelpText2: 'Seçilen sayfa, ilk {partName} oluşumundan sonra kitap başına bir kez eklenir.',
  assemblyCreatorSuccessSubtitle: 'Hotpoint bağlantıları ve kitabın içerik tablosu değişiklikleri hemen yapılacaktır. Dizinleme tamamlandığında arama sonuçları yansıtılacaktır.',
  assemblyCreatorSuccessTitle: 'Gönderilen derleme işini oluştur',
  assemblyStepOne: '1. Adım: Eklenecek sayfayı seçin',
  assemblyStepTwo: '2. Adım: Sayfanın eklenmesini istediğiniz kitapları seçin',
  asset: 'Varlık | Varlıklar',
  assetsNotFound: '{type} Bulunamadı',
  assignBrowseFlow: 'Göz Atma Akışı Ata',
  assignMedia: 'Medya Ata',
  assignMediaToItem: '{item} konumuna Medya Atayın.',
  assignedOrganizations: 'Atanmış Kuruluşlar',
  associateProductPage: 'Mevcut Ürün Sayfasını İlişkilendirme',
  associateProductPageDescription: 'Ürün sayfalarını bu medyayla ilişkilendirin.',
  associateProductPageTip: 'İpucu: "Yeni Ürün Sayfası Oluştur" seçeneğine tıkladığınızda, ilişkilendirmek istediğiniz ürün henüz mevcut değilse yeni bir ürün sayfası eklemek için bir sekme açılır. Yeni ürün sayfası oluşturduktan sonra, ilişkilendirmek için yine bu sayfaya dönmeniz gerekir.',
  associateProducts: 'Ürünleri İlişkilendirme',
  atLeastFiveError: 'Lütfen 5‘ten az olmayan bir değer seçin.',
  attachRelatedPDFs: 'İlgili parça sayfalarının PDF’lerini ekle',
  attachment: 'Ek | Ekler',
  attachmentEditorDescription: 'Resimleri, videoları ve belgeleri doğrudan bu varlığa ekleyin. Bunları "İlgili" sekmesinde bulabileceğinizi unutmayın.',
  attachmentEditorDescriptionPP: 'Resimleri, videoları ve belgeleri doğrudan bu varlığa ekleyin.',
  attachmentFileUploadSizeError: 'Dosya boyutu 50 MB sınırını aşıyor',
  attachmentView: 'Ekleri Görüntüle',
  attributions: 'Özellikler',
  august: 'Ağustos',
  autoHideEmptyCards: 'Boş Kartları Otomatik Gizle',
  autoHotpoint: 'Otomatik Etkin Nokta',
  autoPopulate: 'Otomatik Doldurma',
  automaticZoom: 'Otomatik Yakınlaştırma',
  availability: 'Kullanılabilirlik',
  back: 'Geri',
  backCover: 'Arka Kapak',
  backStitch: 'Arka Dikiş',
  backToLibrary: 'Kütüphaneye Geri Dön',
  backToSearch: 'Aramaya Geri Dön',
  badCredentials: 'Hatalı Kimlik Bilgileri',
  badDefaultValueMessage: 'Varsayılan değer {min} ile {max} karakter arasında olmalıdır.',
  bahasaDescription: 'Bahasa Endonezce Açıklama',
  bahasaName: 'Bahasa Endonezce Ad',
  banner: 'Banner',
  banners: 'Banner\'ler',
  barColor: 'Çubuk Rengi',
  before: 'Önce',
  beginTypingToFindAnything: 'Arama yapmak için yazmaya başlayın',
  beta: 'Beta',
  betaAccessKeys: 'Beta Erişim Anahtarları',
  betaReleaseVideo: 'Beta Sürüm Videosu',
  betaResources: 'Beta Kaynakları',
  blobFinder: 'BLOB Sorgulayıcı',
  body: 'Gövde',
  bom: 'BOM',
  bomDefaultSupplier: 'BOM Varsayılan Tedarikçi',
  bomExportSuccess: 'BOM Dışa Aktarma Başarılı',
  bomItem: 'BOM Öğesi',
  bomItems: 'BOM Ögeleri',
  bomLayout: 'Malzeme Listesi Planı',
  bomListOptions: 'Malzeme Listesi Seçenekleri',
  bomListSettings: 'Malzeme Listesi Ayarları',
  book: 'Kitap | Kitaplar',
  bookInserts: 'Kitap Eklemeleri',
  bookLabel: 'Kitap | Kitaplar',
  bookPrintingDisable: 'Kitap Yazdırmayı Devre Dışı Bırak',
  booksAndPagesDisplay: 'Kitaplar ve Sayfa Görünümü',
  boost: 'Arama Artırma',
  boostDescription: 'Bu etiketin arama uygunluğunu parça numaraları, medya tanımlayıcıları ve isimler üzerinden artırmak için 1,5`in üzerinde bir değer ekleyin',
  boostRangeInvalid: 'Takviye 0,5 ila 100,0 arasında olmalıdır',
  border: 'Kenarlık',
  both: 'Her İkisi',
  bottom: 'Alt',
  branding: 'Markalaşma',
  browse: 'Göz At',
  browseComputer: 'Bilgisayara Göz At',
  browseFlow: 'Akışa Göz At | Akışlara Göz At',
  browseFlowAssigned: 'Göz Atma Akışı Atandı',
  browseFlowCopyMessage: 'Yeni Göz Atma Akışı için benzersiz bir ad girin.',
  browseFlowDeleteMessage: 'Bir göz atma akışı silindiğinde, yalnızca göz atma akışı değil, tüm alt göz atma akışları da silinir.',
  browseFlowDeleted: 'Göz Atma Akışı Silindi',
  browseFlowEmptyState: 'Tanımlanmış Göz Atma Akışı yok. Başlamak için {new}.',
  browseFlowHierarchy: 'Göz Atma Akışı Hiyerarşisi',
  browseFlowMediaCategoryProductPageHelpText: 'Değişiklikleri uygulamak için yeni eklenmiş “Tür: Ürün Sayfası” arama kriterini silin.',
  browseFlowMoveToRoot: 'Birinci seviye alt kuruluş yapmak için düğümü buraya bırakın',
  browseFlowNoAssignedOrgs: 'Atanan kuruluş yok',
  browseFlowNoExistingCriteria: 'Bu göz atma akışı için herhangi bir arama kriteri belirlenmedi. Arama kriterlerini seçmek için yukarıdaki kontrolleri kullanın.',
  browseFlowNoExistingCriteriaBelow: 'Bu göz atma akışı için herhangi bir arama kriteri belirlenmedi.  Arama kriterini seçmek için aşağıdaki kontrolleri kullanın.',
  browseFlowSaveFailed: 'Göz Atma Akışı güncellenemedi',
  browseFlowSaved: 'Göz Atma Akışı kaydedildi',
  browseFlowSelectionRequired: 'Göz atma akışı seçimi gerekli.',
  browseFlowSetDefaultSuccess: 'Varsayılan Göz Atma Akışı seti',
  browseFlowThumbnailDeleteFailTitle: 'Küçük Resim Silinemedi',
  browseFlowThumbnailDeleteSuccessTitle: 'Küçük Resim Silme Başarılı',
  browseFlowThumbnailUploadFailTitle: 'Küçük Resim Yüklenemedi',
  browseFlowThumbnailUploadSuccessTitle: 'Küçük Resim Yükleme Başarılı',
  browseFlowTooManyOrgs: 'Mevcut göz atma akışı düzenleyicisini kullanamayacak kadar çok kuruluşunuz var. Lütfen Documoto göz atma akışlarınızı düzenleme konusunda yardım için {email} adresinden Documoto Destek Merkezi ile iletişime geçin.',
  browserDeprecation: {
    text: 'Microsoft`un Internet Explorer (tüm sürümler) desteğini aşamalı olarak kaldırması ve ilgili güvenlik endişeleri doğrultusunda, 30 Eylül 2021`den sonra kullanıcıların Internet Explorer (tüm sürümler) aracılığıyla bu siteye erişimini artık destekleyemeyeceğiz.',
    title: 'Tarayıcının Kullanımdan Kaldırılma Bildirimi'
  },
  browserPartiallySupport: 'Bu tarayıcıda estetik farklılıklar ve başka değişiklikler görebilirsiniz.',
  buildHotpointLinks: 'Hotpoint Bağlantıları Oluşturun',
  buildHotpointLinksInfo: 'Bu eylem önce tüm mevcut hotpoint bağlantılarını kitabın sayfalarından kaldıracak, ardından parçalar ve eşleşen tüm kurulum sayfaları arasında yeni hotpoint bağlantıları oluşturacaktır.',
  buildHotpointLinksTitle: 'Bu kitap üzerinde hotpoint bağlantıları oluşturmak istiyor musunuz?',
  bulkApplyAllOrgs: 'Tüm Kuruluşlara Toplu Halde Uygula',
  bulkApplyAllOrgsModalMsg: 'Bu içeriğe erişim izni vermek istediğinizden ve bu izni tüm kuruluşlara uygulamak istediğinizden emin misiniz? "Onayla" düğmesine tıklandığıında erişim izni tüm kuruluşlara derhal uygulanır ve Erişim Kontrolleri’ndeki değişiklikler kaydedilir.',
  bulkExportConfirm: '{n} {unit} ögesini dışa aktarmak istiyor musunuz?',
  bulkExportLimit: 'Sınır, dışa aktarılan iş başına {limit} kitaptır',
  bulkImport: 'Toplu İçe Aktarma',
  bulkIndexingLane: 'Toplu Dizinleme Yolu',
  bulkInsert: 'Toplu Ekleme',
  bulkPageInsertJob: 'Toplu Sayfa Ekleme',
  bulkRemoveAllOrgs: 'Tüm Organizasyonlardan Toplu Halde Kaldır',
  bulkRemoveAllOrgsModalMsg: 'Bu içeriğe yönelik erişim iznini tüm kuruluşlar için kaldırmak istediğinize emin misiniz? "Onayla" düğmesine tıklandığında erişim izni tüm kuruluşlar için derhal kaldırılır ve Erişim Kontrolleri’ndeki değişiklikler kaydedilir.',
  business: 'İşletme',
  button: 'Düğme',
  cameraSettings: 'Kamera Ayarları',
  cancel: 'İptal',
  cancelAssemblyCreatorSubtitle: 'Derleme oluşturma işleme alınmayacaktır.',
  cancelAssemblyCreatorTitle: 'Derlemeyi iptal et?',
  canceled: 'İptal Edildi',
  cannotExceed100: '%100‘ü geçemez',
  cannyWidgetLoadFailure: 'Geri bildirim forumu yüklenemedi',
  cart: 'Sepet | Sepetler',
  cartBehaviorDisabled: 'Sepete Ekle Miktar İstemini Devre Dışı Bırak',
  cartBehaviorEnabled: 'Sepete Ekle Miktar İstemini Etkinleştir',
  cartBehaviorLabel: 'Sepete Ekle Miktarı Davranışı',
  cartColumn: 'Sepet Sütunu | Sepet Sütunları',
  cartColumn1: '1. Alışveriş Sepeti Fiyat Sütunu',
  cartColumn2: '2. Alışveriş Sepeti Fiyat Sütunu',
  cartColumn3: '3. Alışveriş Sepeti Fiyat Sütunu',
  cartColumnPartLocationContent1: 'Bu özelliği etkinleştirmenin aşağıdaki sonuçları olacaktır:',
  cartColumnPartLocationContent2: 'Alışveriş sepetindeki parça satırı benzersizliği, varsa bir içerik içerisindeki konumuna da bağlı olacaktır.',
  cartColumnPartLocationContent3: 'Bu ayar kuruluş düzeyinde devre dışı bırakılamaz ve tüm kullanıcılar için geçerli olacaktır.',
  cartColumnPartLocationContent4: 'Sepet Gönderme entegrasyonunuz varsa bu ayar öncelikle Documoto Müşteri Başarı Yöneticinizle iletişim kurmadan etkinleştirilmemelidir.',
  cartColumnPartLocationOption: 'Sepetteki Parça-Konum Verilerini Etkinleştir',
  cartColumnPartLocationTitle: 'Sepetteki Parça-Konum Verilerini etkinleştirmek istediğinizden emin misiniz?',
  cartDisable: 'Alışveriş Sepetini Devre Dışı Bırak',
  cartEmailFailed: 'Sepet E-postası gönderilemedi',
  cartEmailSent: 'Sepet E-postası gönderildi',
  cartEnable: 'Alışveriş Sepetini Etkinleştir',
  cartErpMessage: 'Erp’ye başarılı şekilde gönderildi',
  cartImportError: 'Sepet içe aktarılırken hata oluştu',
  cartLoadedWithItemsRemoved: '{count} öğe, şu anda bu öğeleri sipariş etme izniniz olmadığından kaldırıldı',
  cartSaveEnable: 'Alışveriş Sepetini Kaydetmeyi Etkinleştir',
  cartSharedAddEdit: 'Paylaşılan Sepetleri Ekle / Düzenle',
  cartUpdated: 'Sepet Güncellendi',
  cartUpdatedAndRemovedCount: 'Sepet Güncellendi; sipariş verilemeyen {count} parça silindi',
  category: 'Kategori | Kategoriler',
  categoryCreated: 'Kategori Oluşturuldu',
  categoryNotFoundError: '403: Varlık kategorisi bulunamıyor',
  categoryUpdated: 'Kategori Güncellendi',
  centimeter: 'Santimetre | Santimetre',
  changeNotification: 'Değişiklik Bildirimi',
  changeScope: '{n} {type} etkilenecek',
  changeUserOrganization: 'Kuruluşu Değiştir',
  chapter: 'Bölüm | Bölümler',
  chapterHeader: 'Bölüm Başlığı',
  chaptersOnly: 'Sadece Bölümler',
  charLimitHelpText: '{min} ile {max} karakter arasında bir değer girin',
  chineseDescription: 'Çince Açıklama',
  chineseName: 'Çince Ad',
  circle: 'Daire',
  city: 'Şehir',
  className: 'Sınıf Adı',
  classicAdminMessage: 'Bu, sizi yönetici modüllerini kullanmak üzere Flex’e geri yönlendirecek.',
  classicAdmins: 'Klasik Yöneticiler',
  classicExporter: 'Klasik Dışa Aktarıcı',
  classicExporterMessage: 'Eski Flash tabanlı içerik dışa aktarma modülü',
  classicOrganizationAdmin: 'Klasik Kuruluş Yöneticisi',
  classicOrganizationAdminMessage: 'Kuruluşları ve kullanıcıları yönetmek için eski Flash Tabanlı kullanıcı yönetimi modülü',
  classicPublisher: 'Klasik Yayıncı',
  classicPublisherMessage: 'İçerik oluşturma ve yazdırma ayarları için eski Flash Tabanlı yayıncı modülü',
  classicReporting: 'Klasik Raporlama',
  classicReportingMessage: 'Eski Flash Tabanlı raporlama modülü',
  classicTenantAdmin: 'Klasik Kiracı Yöneticisi',
  classicTenantAdminMessage: 'Kiracı çapında ayarlar için eski Flash Tabanlı yönetim modülü',
  clear: 'Temizle',
  clearFilters: 'Filtreleri Temizle',
  clearHotpoints: 'Hotpointleri temizle',
  clearItemNumber: 'Öge Numarasını Temizle',
  clearItemNumberMessage: '"Öge numarasının silinmesi aşağıdaki verilerin silinmesine neden olacaktır:',
  clearItemNumberTitle: 'Öge numarasını temizlemek istiyor musunuz?',
  clearSearch: 'Aramayı Temizle',
  clickAction: 'Eylem\'e tıklayın',
  clickHereToUpload: 'Dosyayı sürükleyin veya yenisini yüklemek için tıklayın.',
  clickMagnifyingGlass: 'Doğrudan Gelişmiş Arama seçeneğine gitmek için büyütece tıklayın.',
  clickOkToContinue: 'Devam etmek için "Tamam"´a tıklayın.',
  clickToDownload: 'İndirmek İçin Tıklayın',
  clickToEnlarge: 'Büyütmek İçin Tıklayın',
  clickToOpen: 'Açmak İçin Tıklayın',
  clipboard: 'Pano',
  clipboardAccessError: 'Lütfen tarayıcı ayarlarınızı Pano erişimine izin verecek şekilde ayarlayın',
  close: 'Kapat',
  closed: 'Kapatıldı',
  collapseAll: 'Tümünü Daralt',
  color: 'Renk | Renkler',
  column: 'Sütun | Sütunlar',
  columnItemType: {
    customText: 'Özel Metin',
    documentTitle: 'Doküman Başlığı',
    horizontalLine: 'Yatay Satır',
    pageName: 'Sayfa Adı',
    pageNumber: 'Sayfa Sayısı',
    printDate: 'Yazdırma Tarihi',
    tenantName: 'Kiracı Adı',
    userName: 'Kullanıcı Adı'
  },
  columnMapping: 'Sütun Eşleme',
  columnName: 'Sütun Adı',
  combinedPage: 'Birleşik Sayfa',
  combinedPageMessage: 'Diyagram üstte, parçalar listesi altta',
  comingSoon: 'Yakında Geliyor',
  commaDelimited: 'Virgülle sınırlandırılmış',
  comment: 'Yorum | Yorumlar',
  commentAdded: 'Yorum eklendi',
  commentCannotBeEmpty: 'Yorum boş bırakılamaz',
  commentDeleted: 'Yorum silindi',
  commentEdit: 'Yorum Ekle / Düzenle',
  commentEditAll: 'Tüm Yorumları Düzenle',
  commentUpdated: 'Yorum güncellendi',
  commentView: 'Yorumları Görüntüle',
  commerceSystem: 'Ticaret Sistemi',
  completed: 'Tamamlandı',
  configuration: 'Yapılandırma | Yapılandırmalar',
  confirm: 'Onayla',
  confirmBrowseFlowApplyToChildren: 'Bu göz atma akışını alt kuruluşlara uygulamak istiyor musunuz?',
  confirmBrowseFlowOverrideToChildren: 'Bu, alt kuruluşlarda ayarlanan, geçersiz kılınmış tüm göz atma akışlarını kaldıracaktır.',
  confirmPrintSettingsApplyToChildren: 'Bu yazdırma ayarını alt kuruluşlara uygulamak istiyor musunuz?',
  confirmPrintSettingsOverrideToChildren: 'Bu, alt kuruluşlarda ayarlanan, geçersiz kılınmış tüm yazdırma ayarlarını kaldıracaktır.',
  contains: 'İçinde geçen',
  containsHeaderRow: 'Üstbilgi Satırını İçerir',
  content: 'İçerik | İçerikler',
  contentAccessControls: '{content} Erişim Kontrolleri',
  contentEntity: 'İçerik Varlığı | İçerik Varlıkları',
  contentNotFound: 'İçerik bulunamadı',
  contentUpdatedQueueJob: 'İçerik Güncelleme Kuyruğu',
  contentViewerMoreInfo: 'Daha Fazla Bilgi',
  contourShape: 'Şeklin Hatlarını Belirle',
  convertEntity: '{entity} varlığını dönüştür',
  convertToEntity: '{entity} varlığına dönüştür',
  copiedPartNumber: 'Kopyalanmış Parça Numarası {partNumber}',
  copy: 'Kopyala',
  copyAccessControls: 'Erişim Kontrollerini Kopyala',
  copyAccessControlsWarning: 'Bu, atanan tüm erişim kontrollerini, seçilen bir Kuruluştan bu mevcut Kuruluşa kopyalayacaktır',
  copyAndRetain: 'Entegrasyon Kullanımı İçin Kopyalayın ve Saklayın',
  copyAndRetainWidget: 'Kopyala ve Sakla, Widget Yetkilendirme değerinin uygulamada size görüneceği tek andır',
  copyAtoB: '{a} ögesini {b} ögesine kopyala',
  copyBranches: 'Dalları Kopyalama',
  copyBranchesMessage: 'Kaynak Göz Atma Akışından seçilen dalları bir Hedef Akışa kopyalayın.',
  copyContent: '{type} kopyala? {name}',
  copyItem: '{item} ögesini kopyala',
  copyItemQuestion: '{item} ögesini kopyala?',
  copyMeMessage: 'Bu ileti için beni bilgiye ekle',
  copyPartNumberToClipboard: '{label} etiketini panoya kopyala',
  copyProduct: 'Ürün Kopyala',
  copyTo: '{target} hedefine kopyala',
  copyingItem: '{item} kopyalanıyor',
  copyrightMessage: '© 2010-{year} Documoto Inc. Tüm hakları saklıdır.',
  count: 'Miktar',
  country: 'Ülke | Ülkeler',
  coverAmpStitchPages: 'Kapak ve Dikiş Sayfaları',
  coverPages: 'Kapak Sayfaları',
  createAssembly: 'Kurulum Oluştur',
  createNewProductPage: 'Yeni Ürün Sayfası Oluşturma',
  created: 'Oluşturuldu',
  createdBy: '{name} tarafından oluşturuldu',
  createdDate: 'Oluşturulma Tarihi',
  createdOn: 'Oluşturulma tarihi',
  currentPassword: 'Mevcut Şifre',
  custom: 'Özel',
  czechDescription: 'Çekçe Açıklama',
  czechName: 'Çekçe Ad',
  dashboard: 'Gösterge Paneli | Gösterge Panelleri',
  dashboardLibrary: 'Pano Kitaplığı',
  dataInsights: 'Veri İçgörüleri',
  dataInsightsInfoMessage: 'İçerik, kullanıcı ve kitaplık veri içgörüleri için Raporlama ve Pano Merkezi.',
  dataMapping: 'Veri Eşleme/Örnek Veriler (en fazla 10 satır)',
  dataOptions: 'Veri Seçenekleri',
  date: 'Tarih',
  dateModified: 'Değiştirilme Tarihi',
  debugPageBuilderPLZ: 'Sayfa Oluşturucu PLZ‘de Hata Ayıkla',
  december: 'Aralık',
  decreaseHotpoint: 'Azaltma Etkin Noktası',
  'default': 'Varsayılan',
  defaultAddress: 'Varsayılan Adres',
  defaultBrowseFlow: 'Varsayılan Göz Atma Akışı',
  defaultCurrencyCode: 'Varsayılan Para Birimi Kodu',
  defaultCurrencySymbolOn: 'Varsayılan Para Birimi Sembolü Açık',
  defaultEmailRecipient: 'Varsayılan E-posta Alıcısı | Varsayılan E-posta Alıcıları',
  defaultImage: 'Varsayılan Resim | Varsayılan Resimler',
  defaultImagesManager: 'Varsayılan Resim Yöneticisi',
  defaultItemImage: '{item} Varsayılan Resim',
  defaultPartsListLayout: 'Varsayılan Parça Listesi Düzeni',
  defaultPartsListLayoutHelp: 'Resmin solunda veya altında varsayılan parça düzeni',
  defaultSearchMode: 'Varsayılan Arama Modu',
  defaultSearchModeHelp: 'Varsayılan genel arama yöntemi \'içerir\' veya \'tam \'',
  defaultSortMode: 'Varsayılan Sıralama Modu',
  defaultSupplier: 'Varsayılan Tedarikçi',
  defaultTocStateOpen: 'Varsayılan İçindekiler Durumu Açık',
  defaultTocStateOpenHelp: 'Bir kitabı görüntülerken İçindekiler`in otomatik olarak açılıp açılmayacağını belirler',
  defaultUom: 'Varsayılan UOM',
  defaultValue: 'Öndeğer',
  defaultView: 'Varsayılan Görünüm',
  defaults: 'Varsayılanlar',
  defaultsAndCapabilities: 'Varsayılanlar ve Yetenekler',
  'delete': 'Sil',
  deleteAll: 'Ana Kuruluştan Devral',
  deleteAnyPartnerApiKeys: 'SmartEquip için sağlanmış olan herhangi bir Partner Uygulama Programı Arabirimi Anahtarını silin.',
  deleteContent: '{type} ögesini silmek istediğinizden emin misiniz? {name}',
  deleteFilesMessage: '{count} dosyayı silmek istediğinizden emin misiniz?',
  deleteHotpointLinksTitle: 'Etkin nokta bağlantılarını silmek istediğinizden emin misiniz?',
  deleteMessage: 'Silmek istediğinizden emin misiniz?',
  deletePart: {
    affectedCarts: 'Bu parçayı içeren tüm sepetlerden parça kalıcı olarak kaldırılacak.',
    deletingPartNumber: '{partNumber} silinecek.',
    infoOne: 'Parça silmeleri, Kütüphane ve İçerik Yöneticisi içinde anında gerçekleşir. Silinen parçalar, birkaç dakika içinde tekrar dizinlenene kadar aranabilir kalır.',
    infoTwo: 'Bu eylem, Documoto Destek yardımı olmadan geri alınamaz. 90 gün sonra silinen kayıt ve tüm bileşenleri, kalıcı olarak silinir.'
  },
  deletePartCollectionConfirmMsg: '{partCollection} ögesini {productPage} sayfasından silmek istediğinizden emin misiniz?',
  deletePartInUse: {
    body: 'Documoto şu an yalnızca sayfalara ait olmayan parçaların silinmesini destekliyor. Silme işlemine devam etmek için lütfen bu parçayı yayınlanmış veya taslak sayfalardan kaldırın.',
    submitLabel: 'Kullanıldığı Sayfaya Git',
    title: 'Bu parça sayfaya ait ve silinemez.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} silinecek.',
    infoOne: 'Ürün sayfası silme işlemleri, Kütüphane ve İçerik Yöneticisi bölümlerinde anında gerçekleşir. Silinen ürün sayfaları, birkaç dakika içinde yeniden dizinleme tamamlanana kadar aranabilir.',
    infoTwo: 'Bu eylem, Documoto Destek ekibinin müdahalesi olmadan geri alınamaz. Silinen kayıt ve tüm bileşenleri, 90 gün sonra kalıcı olarak silinir.'
  },
  deleteRelated: ' {count} {type} ögesini silmek istediğinizden emin misiniz?',
  deleteSelectedCriteria: 'Seçilen Kriterleri Sil',
  deleteTagsTitle: 'Etiketleri silmek istediğinizden emin misiniz?',
  deleteTaxonMessage: 'Bu, alt kuruluşları ile birlikte bu taksonu kalıcı olarak silecek. `Devam etmek istediğinizden emin misiniz?',
  deleteTaxonomyMessage: 'Bu, bu Kuruluş veya Kiracı için tüm taksonları kalıcı olarak silecek. Devam etmek istediğinizden emin misiniz?',
  deleteTenantSupplier: 'Kiracı için bu sağlayıcıyı silmek istediğinizden emin misiniz?',
  deletedItem: '{item} silindi',
  demo: 'Demo',
  description: 'Açıklama',
  deselectAll: 'Tüm Seçimleri Kaldır',
  deselectCriteria: 'Kriter Seçimini Kaldır',
  detail: 'Ayrıntı | Ayrıntılar',
  diagonal: 'Diyagonal',
  diameter: 'Çap',
  disable: 'Devre Dışı Bırak',
  disableAll: 'Tümünü Devre Dışı Bırak',
  disableDocumotoTenant: 'Documoto Kiracısını Devre Dışı Bırak',
  disableFwdReindex: 'DSW için Yönlendirme Yeniden Dizinleme Hedef Medyasını Devre Dışı Bırak',
  disableLibraryBannerImage: 'Kitaplık Başlığı Resmini Devre Dışı Bırak',
  disableSmartEquipModalTitle: 'Bu lisansı devre dışı bırakmak istediğinizden emin misiniz?',
  disableTEK: 'Doğrudan URL ile Oturum Açmayı Devre Dışı Bırak',
  disableUserLogin: 'Kullanıcı Adı/Parola ile Oturum Açmayı Devre Dışı Bırak',
  disableUserLoginErrorMessage: 'Kuruluşunuz SSO ile kimlik doğrulama kullanıyor. Kullanıcı grubunuzun kullanıcı adı/parola ile oturum açmasına izin verilmiyor. Lütfen SSO kullanarak oturum açın.',
  disableUserLoginTooltip: 'Bunun etkinleştirilebilmesi için çalışan bir SSO yapılandırması gereklidir. SSO kurulumu yapılmadığından, etkilenen kullanıcılar Documoto’ya erişimini kaybedecek.',
  disabled: 'Devre Dışı Bırakıldı',
  discard: 'Göz Ardı Et',
  discardChanges: 'Değişiklikleri göz ardı et',
  discardQ: 'Değişiklikler göz ardı edilsin mi?',
  discountPrice: 'İndirim Fiyatı',
  discounted: 'İndirimli',
  discountedPrice: 'İndirimli Fiyat',
  discountedTotal: 'Toplam İndirim',
  displayInOrdersList: 'Sipariş Listesinde Görüntüle',
  displayLocation: 'Ekran Konumu',
  displayOrder: 'Görüntüleme Sırası',
  displayOrderDescription: 'İçerik türü etiketleri için Filtreler açılır menüsünün görüntülenme sırasını ayarlar',
  displaySupplierPartInfo: 'Parça Bilgisinde Tedarikçiyi Gösterme',
  document: 'Doküman| Dokümanlar',
  documentLabel: 'Doküman| Dokümanlar',
  documentSettings: 'Doküman Ayarları',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Documoto Lisans Paketi',
  domain: 'Etki Alanı',
  domainEmptyMessage: 'İzin Verilen Etki Alanı boş olamaz',
  domainInvalidMessage: 'Geçerli bir etki alanı adı gereklidir',
  download: 'İndir',
  downloadBrowser: 'Bu büyük tarayıcılardan birini indirin.',
  downloadFailed: 'İndirme hatası {name}',
  downloadStarted: 'Şunun için indirme devam ediyor: {name}',
  draft: 'Taslak | Taslaklar',
  draftBomDeleteTitle: 'Bu parçayı sayfadan silmek istediğinizden emin misiniz?',
  draftBomDropError: 'Parçalar 5 düzeyden daha derin iç içe yerleştirilemez',
  draftBomEmptyField: 'Parçalar Listesi’ndeki tüm alanlar tamamlanmalıdır',
  draftBomError: 'Malzeme Listesi değiştirilirken hata oluştu',
  draftBomMultipleDeleteTitle: 'Bu kısımları sayfadan silmek istediğinizden emin misiniz?',
  draftBomQuantityError: 'Miktar bir sayı olmalıdır',
  draftPage: 'Taslak Sayfa',
  draftPageDelete: 'Taslağı Sil',
  draftPageDeleteMessage: 'Taslak sayfa başarıyla silindi.',
  draftPageDeleteWarning: 'Sayfa taslağını silmek devam eden güncellemeleri kaldırır.',
  draftPageLastUpdated: 'Taslak - Son Güncelleme: {date} Güncelleyen: {username}',
  draftPageLoadError: 'Taslak sayfa yüklenemedi.',
  draftPageProcessingPlz: 'PLZ dosyasından yüklenmekte olan sayfa',
  draftPagePublishInProgress: 'Sayfa Yayımlama İşi devam ediyor',
  draftPageSaveSuccess: 'Taslak sayfa başarıyla kaydedildi.',
  draftPageSaveUnsuccessful: 'Taslak sayfa kaydedilemedi.',
  draftSheetImageHotpointsFailure: 'Taslak sayfa görüntüsü için {algorithm} hotpointleri oluşturulamıyor.',
  draftValidationMessage: {
    empty: 'Doğrulama Hatası/Uyarısı Yok',
    hotpointOrHotpointLink: 'Malzeme Listesinin {item} öğesinin etkin noktaları/etkin nokta bağlantıları belirtilmemiş',
    item: 'UYARI: BOM Parça Numarası {partNumber} için Öge Numarası belirtilmemiş',
    quantity: 'Malzeme Listesinin {item} öğesinin miktarı belirtilmemiş',
    supersede: 'Bölüm {partNumber} değiştirilme nedeniyle {supersededPartNumber}‘nın yerini aldı.',
    tag: 'Malzeme Listesinin {item} öğesinin {tagName} etiketinin değeri eksik',
    translationDescription: 'Malzeme Listesinin {item} öğesinin {lang} dilinde çevirisi eksik',
    uom: 'Malzeme Listesinin {item} öğesinin ölçü birimi belirtilmemiş'
  },
  drawAutohotpointRegion: 'Boyut {shape} çizin',
  drawMinimumArea: 'Minimum alan çizin',
  dropFileMessage: 'Dosyayı buraya sürükleyin veya yüklemek için tıklayın.',
  duplicate: 'Çoğalt',
  duplicateSaveError: 'Tekrarlanan girdi. Kaydedilemedi.',
  dutchDescription: 'Hollandaca Açıklama',
  dutchName: 'Hollandaca Ad',
  dynamic: 'Dinamik',
  dynamicNaming: 'Dinamik Adlandırma',
  ecommerce: 'E-ticaret',
  ecommerceEmailFormatCreated: 'E-Ticaret E-posta Formatı oluşturuldu',
  ecommerceEmailFormatSaved: 'E-Ticaret E-posta Formatı kaydedildi',
  ecommerceLogo: 'E-ticaret Logosu',
  ecommerceUseExtOrder: 'E-ticaret Kullanımı Harici Sipariş Numarası',
  edit: 'Düzenle',
  editItem: '{item} düzenle',
  email: 'E-posta',
  emailAsCsv: 'CSV Olarak E-Posta ile Gönder (İçe Aktarma için Gerekli Format)',
  emailAsXlsx: 'XLSX Olarak E-Posta ile Gönder',
  emailBasicPartInfo: 'Temel Parça Bilgilerini E-Posta ile Gönder',
  emailComments: 'E-Posta Yorumları',
  emailDetails: 'E-Posta Bilgileri',
  emailDisplayedCartColumns: 'Gösterilen Sepet Sütunlarını E-Posta ile Gönder',
  emailFormat: 'E-posta Formatı',
  emailFormatTemplate: 'E-posta Biçim Şablonu | E-posta Biçim Şablonları',
  emailList: 'E-Posta Listesi',
  emailMessage: 'E-posta gerekli',
  emailRecipient: 'E-posta Alıcısı | E-posta Alıcıları',
  emailRecipientMessage: 'Sipariş durumu değiştiğinde bu e-posta adresleri bir e-posta alacak',
  emailSubject: 'E-Posta Konusu',
  emptyBomState: 'Sayfa için hiç BOM Öğesi tanımlanmadı. Başlamak için +{add} öğesine tıklayın',
  emptyMessage: {
    orderSuggestions: 'Görünüşe göre bu bölüm için henüz Sipariş Önerisi yok.'
  },
  enable: 'Etkinleştir',
  enable3d: '3D’yi Etkinleştir',
  enable3dIllustrations: '3D Çizimlerini Etkinleştir',
  enable3dThumbnails: '3D Küçük Resimleri Etkinleştir',
  enableAPIKeyAdmin: 'API Anahtar Yöneticisini Etkinleştir',
  enableAll: 'Tümünü Etkinleştir',
  enableCommerce: 'Ticareti Etkinleştir',
  enableEcommerceOrderManagement: 'Sipariş Yönetimini Etkinleştir',
  enableExportToLinkOne: 'LinkOne‘a Dışa Aktarmayı Etkinleştir',
  enableExportToSmartEquip: 'SmartEquip‘e Dışa Aktarmayı Etkinleştir',
  enableExporter: 'Dışa Aktarıcıyı Etkinleştir',
  enableIframeSupport: 'iFrame Desteği’ni Etkinleştir',
  enableKnowledgeBase: 'Yapay Zeka Destekli Aramayı Etkinleştirme',
  enableLibraryBetaFeatures: 'Kütüphane Beta Özellikleri ögesini etkinleştir',
  enableMediaCategorySearch: 'Bağlamsal Aramada Medya Kategorilerine Göre Gruplandırmayı Etkinleştirme',
  enablePDFDownloadWarning: 'Büyük PDF Dosyası İndirme Uyarısını Etkinleştir',
  enablePLZToDraft: 'Taslağa PLZ İşlemini Etkinleştir',
  enablePerformanceLogging: 'Performans Günlüğünü Etkinleştir',
  enableQuickAddToCart: 'Sepete Hızlı Ekleme’yi Etkinleştir',
  enableQuickAddToCartHelpContext: 'Bu seçeneği “Etkin” olarak ayarladığınızda bu içerik için yukarıdaki içerik görüntüleyicileri üzerinde yer alan Sepete Hızlı Ekleme özelliği etkinleştirilecektir.',
  enableRocketUi: 'Rocket Kullanıcı Deneyimini Etkinleştir',
  enableSmartEquipApiIntegration: 'SmartEquip Uygulama Programı Arabirimi Entegrasyonunu Etkinleştir',
  enableWidgetLogo: 'Documoto Widget Logosu ögesini etkinleştir',
  enableWidgets: 'Widgetlar ögesini etkinleştir',
  enabled: 'Etkinleştirildi',
  encryptedKey: 'Şifreli Anahtar',
  endDate: 'Bitiş Tarihi',
  endDateBad: 'Başlama tarihi, bitiş tarihiyle aynı veya daha önce olmalı.',
  enforceNumericSize: 'Sayısal Boyutu Zorla',
  englishDescription: 'İngilizce Açıklama',
  englishName: 'İngilizce Ad',
  enterReportParameters: 'Rapor Parametrelerini Gir',
  enterUniqueNameForNewItem: 'Yeni {item} için benzersiz bir ad girin',
  enterValidEmail: 'Lütfen geçerli bir e-posta girin',
  enterValidNumber: 'Lütfen geçerli bir numara girin',
  enterprise: 'Kurumsal',
  entityType: 'Varlık Türü | Varlık Türleri',
  erp: 'ERP',
  erpEndpointConfig: 'ERP Uç Nokta Yapılandırması',
  erpPartInfo: 'ERP Parça Bilgisi Önbellek Süresi Dakika',
  erpSystem: 'ERP Sistemi',
  erpSystemSaved: 'ERP Sistemi Kaydedildi',
  erpSystems: 'ERP Sistemleri',
  error: 'Hata',
  errorDeletePageMessage: 'Sayfa silinirken bir hata oluştu.',
  errorInputParsing: 'Giriş dosyası ayrıştırılırken sorun oluştu.',
  errorPageMessage: 'Bir hata meydana geldi.',
  errorPageTitle: 'Bir sorun oluştu...',
  errorType: {
    error: 'Hata',
    warning: 'Uyarı'
  },
  essential: 'Temel Unsur | Temel Unsurlar',
  eta: 'ETA',
  etlJob: 'ETL',
  exact: 'Tam adı',
  excelFile: 'Excel Dosyası',
  existing: 'Mevcut',
  expandAll: 'Tümünü Genişlet',
  'export': 'Dışa Aktar',
  exportAsCSVDropdown: 'CSV Olarak Dışa Aktar',
  exportAsCsv: 'CSV Olarak Dışa Aktar (İçe Aktarma için Gerekli Format)',
  exportAsHtml: 'HTML olarak dışarı aktar',
  exportAsPdf: 'PDF olarak dışa aktar',
  exportAsPlz: 'PLZ olarak dışa aktar',
  exportAsXlsx: 'XLSX olarak dışa aktar',
  exportBasicPartInfo: 'Temel Parça Bilgilerini Dışa Aktar',
  exportCartToXlsxDisabled: 'Sepeti XLSX`e Aktarmayı Devre Dışı Bırak',
  exportCartToXlsxEnabled: 'Sepeti XLSX`e Aktarmayı Etkinleştir',
  exportDisplayedCartColumns: 'Gösterilen Sepet Sütunlarını Dışa Aktar',
  exportJob: 'Dışa Aktarma İşi',
  exportLane: 'Yolu Dışa Aktar',
  exportMessage: 'Dışa aktarma işi başarılı şekilde gönderildi.',
  exportParts: 'Parçaları Dışarı Aktar',
  exportPartsXlsx: 'Parçaları XLSX’e Aktar',
  exportSearch: 'Aramayı Dışa Aktar',
  exporter: 'Dışa Aktarıcı',
  exporterMessage: 'İçeriği dışa aktarmanızı sağlar',
  external: 'Harici | Hariciler',
  externalUrl: 'Harici URL',
  faceted: 'Yönlü',
  facetedTag: 'Filtre değerleri yönlü olmalıdır',
  facetedTagTooMany: 'Etiket 1.000 benzersiz etiket değeri sınırını aşıyor',
  failedAction: '{content} için {action} gerçekleştirilemedi.',
  failedProcessContentSql: 'Yetkilendirilmemiş metin nedeniyle İçeriği İşleme başarısız oldu. Lütfen desteklenen içeriği tekrar yükleyin.',
  failedToCopy: '{content} kopyalanamadı.',
  failedToDelete: '{content} silinemedi.',
  failedToLoad: '{content} yüklenemedi.',
  failedToSave: '{content} silinemedi.',
  failedToSubmitFeedback: 'Geri bildirim gönderilemedi.',
  failedToSubmitItem: '{item} gönderilemedi',
  failedToUpdate: '{content} güncellenemedi.',
  'false': 'Yanlış',
  faq: 'SSS',
  favorites: 'Favoriler',
  favoritesLists: 'Favoriler Listesi',
  february: 'Şubat',
  feedbackForm: 'Geri Bildirim Gönder',
  feedbackFormMessage: 'Görmek istediğiniz özellikler için giriş yapın',
  field: 'Alan | Alanlar',
  fieldDefinition: 'Alan Tanımı',
  fieldName: 'Alan Adı',
  file: 'Dosya | Dosyalar',
  fileUpload: 'Dosya Yükleme',
  filename: 'Dosya Adı',
  filesSubmitted: 'Dosya(lar), işlenmek üzere kaydedildi',
  fill: 'Dolgu',
  filter: 'Filtre | Filtreler',
  filterBoundsError: 'Filtre en az 3 veya daha fazla karakter içermelidir',
  filterBy: 'Filtreleme Kriteri',
  filterOrgNameOnly: 'Filtreleyin, Org Name Only',
  filterOrgParentNames: 'Filter: Organizasyon ve Üst Adlar',
  filterable: 'Filtrelenebilir',
  filterableTag: 'Filtrelenebilir Etiket',
  finnishDescription: 'Fince Açıklama',
  finnishName: 'Fince Ad',
  firstName: 'Ad',
  firstNameEmpty: 'Ad boş bırakılamaz',
  fixedHotpointSize: 'Sabit Hotpoint Boyutu',
  font: 'Font | Fontlar',
  footer: 'Altbilgi',
  forSearchTerm: '{term} için',
  forgotPassword: 'Parolamı Unuttum',
  forgotPasswordMessage: 'Parolanızı sıfırlamak için gerekli talimatları içeren bir e-posta, sağladığınız kullanıcı adına gönderilecektir.',
  forgotPasswordSuccess: 'Parolanızı sıfırlamak için gerekli talimatları içeren bir e-posta, sağlanan kullanıcı adı geçerliyse dosyadaki adrese gönderilecektir.',
  form: 'Form | Formlar',
  formCount: 'Form Sayısı',
  formName: 'Form Adı',
  formType: 'Form Türü',
  format: 'Format',
  formattingOptions: 'Biçimlendirme Seçenekleri',
  freezeImage: 'Görüntüyü Dondur',
  frenchDescription: 'Fransızca Açıklama',
  frenchName: 'Fransızca Ad',
  fri: 'Cum',
  from: 'Kimden',
  fromDate: 'Başlangıç Tarihi',
  frontCover: 'Ön Kapak',
  frontStitch: 'Ön Dikiş',
  fullScreen: 'Tam Ekran',
  gdprFaqs: 'GDPR ile ilgili SSS',
  gdprMessage: 'Web sitemizin bu bölümünde oturum açarak gerekli çerezler kullandığımızı kabul etmiş oluyorsunuz. Bu çerezler, Hizmetlerimize gitmenizi sağlamak için gereklidir. Bu çerezler olmadan talep ettiğiniz hizmetleri sağlayamayız. Daha fazla bilgi için bkz. {policy}.',
  general: 'Genel',
  generalSearch: 'Genel Arama',
  generalSearchCriteriaAlreadySet: '"Genel Arama" arama kriteri zaten ayarlandı.',
  generic: 'Genel',
  germanDescription: 'Almanca Açıklama',
  germanName: 'Almanca Ad',
  goTo: 'Şuraya Git:',
  goToHome: 'Ana Sayfaya Git',
  goToJobManager: 'İş Yöneticisine Git',
  goToPartCollections: '{partCollections} sayfasına git',
  goToSearch: 'Aramaya Git',
  gotIt: 'Anladım',
  hashKey: 'Kare Tuşu',
  header: 'Başlık',
  headerAmpFooter: 'Üstbilgi ve Altbilgi',
  help: 'Yardım',
  helpCenter: 'Yardım Merkezi',
  hideBookInSearchAndRecent: 'Arama Sonuçlarında ve Son Eklenenlerdeki Kitapları Gizle',
  hideDuplicatePages: 'Yinelenen Sayfaları Gizle',
  hidePageInSearchAndRecent: 'Arama Sonuçlarında ve Son Eklenenlerdeki Sayfaları Gizle',
  hidePartInSearchAndRecent: 'Arama Sonuçlarında ve Son Eklenenlerdeki Parçaları Gizle',
  highlightDescription: 'Bu etiketle parça listesindeki parçaları vurgulayın',
  history: 'Geçmiş',
  home: 'Ana Sayfa',
  homePageSettings: 'Ana Sayfa Ayarları',
  homepageOnly: 'Sadece Ana Sayfa',
  horizontal: 'Yatay',
  host: 'Etki Alanı',
  hotpoint: 'Hotpoint | Hotpoint’ler',
  hotpointCalloutBehavior: 'Hotpoint Belirtme Çizgisi Davranışı',
  hotpointLink: 'Etkin Nokta Bağlantısı | Etkin Nokta Bağlantıları',
  hotpointLinksWillBeCreated: 'Hotpoint bağlantıları {count} {content} içinde oluşturulacak',
  hotpointShift: 'Etkin nokta (Shift H)',
  hotpointZoomBehavior: 'Hotpoint Yakınlaştırma Hareketi',
  hotpointsGenerated: 'Görüntüde {count} önemli nokta bulundu.',
  hourlyDWSRequestLimit: 'Saatlik DWS Talep Limiti',
  hourlyRESTRequestLimit: 'Saatlik REST Talep Limiti',
  htmlUiUserSwitchEnabled: 'HTML Kullanıcı Arayüzü Kullanıcı Anahtarı Etkin',
  hungarianDescription: 'Macarca Açıklama',
  hungarianName: 'Macarca Ad',
  icon: 'İkon',
  id: 'Kimlik',
  identifier: 'Tanımlayıcı',
  identifierRequiredErrorMessage: 'Bir tanımlayıcı gerekli',
  ignore: 'YOK SAY',
  ignoreAccessControls: 'Erişim Kontrollerini Yoksay',
  ignoreMatchingTranslations: 'İçeri aktarırken eşleşen yerel ayarlara sahip Çevirileri yoksay',
  illustration: 'Çizim | Çizimler',
  image: 'Resim| Resimler',
  imageDeleteMessage: 'Bu Sayfa Resmini silmek istediğinizden emin misiniz?',
  imageDimensionsExceededMessage: 'Documoto’da en fazla resim boyutu 65,5 megapikseldir (8.191 X 8.191 piksel).  Karşıya yüklemeye çalıştığınız resim en büyük boyutu aştı ve yüklenemiyor. Documoto’nun resmi yeniden boyutlandırıp eklemesine izin vermek için "Yeniden Boyutlandır" seçeneğine veya resmi el ile düzenleyip eklemek için "İptal" seçeneğine tıklayın',
  imageOptimizer: 'Görüntü İyileştirici',
  imageSaveFail: 'Resim Kaydedilemedi',
  imageSaveSuccess: 'Resimler Başarıyla Güncellendi',
  imageSizeExceededMessage: 'Documoto‘da izin verilen maksimum resim boyutu {size} megabayttır. Karşıya yüklemeye çalıştığınız resim maksimum boyutu aştığı için yüklenemiyor. Lütfen bu sayfaya eklenecek resmi yeniden boyutlandırın.',
  imageSizeExceededTitle: 'En Fazla Resim Boyutu Aşıldı',
  imageUploadFailure: 'Resim Karşıya Yüklenemedi',
  'import': 'İçe Aktar',
  importBOM: 'Malzeme Listesini İçeri Aktar',
  importBOMError: 'Örnek veriler işlenemedi, giriş kaynağını yeniden denetleyin',
  importName: 'İçe Aktarım Adı',
  importParts: 'Parçaları İçeri Aktar',
  inCart: 'Sepette',
  inCartDescription: 'Sepette etiketleri görüntüle',
  inPartsList: 'Parça Listesinde',
  inPartsListDescription: 'Etiketleri parça listesinde görüntüle',
  inch: 'İnç | İnç',
  includeComments: 'Yorumları Dahil Et',
  includeCommentsAuthorAndDate: 'Yorum Yazarını ve Tarihi Dahil Et',
  includeHeaderRow: 'Üst bilgi Satırını Dâhil Et',
  includeImages: 'Resimleri Dahil Et',
  includeNewParts: 'Yalnızca "yeni" bölümleri dâhil et (Documoto‘da değil)',
  includePagePartDetails: 'Sayfa Bölümü düzeyinde ayrıntıları dâhil et',
  includePagesIndex: 'Sayfa Endeksini Dahil Et',
  includePartDetails: 'Bölüm düzeyinde ayrıntıları dâhil et',
  includePartsIndex: 'Parça Endeksini Dahil Et',
  includePartsList: 'Parça Listesini Dahil Et',
  includeSubChapters: 'Alt Bölümleri Dahil Et',
  includeWatermark: 'Filigran dahil edilsin mi?',
  increaseHotpoint: 'Etkin Noktayı Artır',
  indefinitely: 'Süresiz olarak',
  indexIncludeTimestamp: 'Dizin Zaman Damgası İçerir',
  indexLane: 'Dizin Yolu',
  indexQueueJob: 'Dizin Kuyruğu',
  indexed: 'Endeksli',
  indexingConfiguration: 'Dizinleme Yapılandırması',
  info: 'Bilgi',
  information: 'Bilgi',
  inherit: 'Devral',
  inherited: 'Devralınan',
  inheritedParent: 'Ana Kuruluştan Devralındı.',
  inputSource: 'Giriş Kaynağı',
  inputSpecification: 'Giriş Bildirimi',
  inputType: 'Girdi Türü',
  inputTypeListboxWarning: 'Yapılandırmaları sıralama, kaydetme işleminin ardından görüntülenecektir',
  insertDataField: 'Veri Alanı Ekle',
  integration: 'Entegrasyon | Entegrasyonlar ',
  integrationsAddPartToErpCart: '{action} Parçayı ERP Sepetine Ekle',
  integrationsAddToShoppingCartPricingFromErp: '{action} ERP`den Alışveriş Sepeti Fiyatlandırmasına Ekle',
  integrationsDisableErp: 'ERP`yi Devre Dışı Bırak',
  integrationsDoErpForQuotes: 'Teklifler İçin ERP Yap',
  integrationsEnableErp: 'ERP`yi Etkinleştir',
  integrationsEnableFetchPartInfoFromErp: 'ERP`den Parça Bilgilerini Getirmeyi Etkinleştir',
  integrationsEnableScopeErp: '{scope} ERP`yi etkinleştir',
  integrationsEnableSendShoppingCartToErp: 'Alışveriş Sepetini ERP`ye Göndermeyi Etkinleştir',
  integrationsEnableSyncPoAddressWithErp: 'ERP ile PO Adresini Senkronize Etmeyi Etkinleştir',
  integrationsErpAvailabilityMappedFrom: 'ERP Kullanılabilirliğinin Eşleştirildiği Yer',
  integrationsErpCurrencyCodeMappedFrom: 'ERP Para Birimi Kodunun Eşleştirildiği Yer',
  integrationsErpDiscountedPriceMappedFrom: 'ERP İndirimli Fiyatın Eşleştirildiği Yer',
  integrationsErpEtaMappedFrom: 'ERP ETA’nın Eşleştirildiği Yer',
  integrationsErpMappings: 'ERP Eşlemeleri',
  integrationsErpRetailPriceMappedFrom: 'ERP Perakende Fiyatının Eşleştirildiği Yer',
  integrationsErpWholesalePriceMappedFrom: 'ERP Toptan Satış Fiyatının Eşleştirildiği Yer',
  integrationsInvokeGetPartInfoFromClient: 'Müşteriden GetPartInfo Çağır',
  integrationsParseAddressForType: 'Tür İçin Adresi Ayrıştır',
  integrationsShoppingCartAndPartsTitle: 'Alışveriş Sepeti ve Parçaları',
  integrationsShoppingCartAvailability: '{action} Alışveriş Sepeti Kullanılabilirliği',
  integrationsShoppingCartEtaFromErp: '{action} ERP`den Alışveriş Sepeti ETA`sı',
  internalApiKey: 'Dahili Uygulama Programı Arabirimi Anahtarı',
  internalDescription: 'Dahili Açıklama',
  internalName: 'Dahili Adı',
  internalNameOptional: 'Etiket için tanımlayıcınız',
  internalNameRequired: 'Bir ad gerekli',
  invalidDecimals: 'Yalnızca iki ondalık basamağa izin verilir',
  invalidField: '{field} geçersiz',
  invalidFileType: 'Dosya türü desteklenmiyor. Desteklenen dosya uzantılarının tam listesi için Documoto Destek Merkezine bakın.',
  isSearchable: 'Aranabilir',
  isSystem: 'Sistemde',
  italianDescription: 'İtalyanca Açıklama',
  italianName: 'İtalyanca Ad',
  item: 'No.',
  itemAlt: 'Öge',
  itemCopied: '{item} kopyalandı',
  itemDeleted: '{item} silindi',
  itemDetails: 'Öge Bilgileri',
  itemInProgress: '{item} devam ediyor',
  itemInformation: '{item} bilgileri',
  itemMustBeLteItem: '{itemA}, {itemB} ögesine eşit veya ondan önce olmalıdır.',
  itemMustBeUnique: '{item} benzersiz olmalıdır',
  itemMustBeUniqueAndNotEmpty: '{item} benzersiz olmalıdır ve zorunludur',
  itemName: '{item} Adı',
  itemSaved: '{item} kaydedildi',
  itemSpecification: 'Öğe Belirtimi',
  january: 'Ocak',
  japaneseDescription: 'Japonca Açıklama',
  japaneseName: 'Japonca Ad',
  job: 'İş | İşler',
  jobManager: 'İş Yöneticisi',
  jobManagerMessage: 'İşleri dışa aktarın, yayınlayın ve yazdırın/indirin',
  july: 'Temmuz',
  june: 'Haziran',
  knowledgeBase: {
    config: {
      fetchUsage: 'Getirme Kullanımı',
      maxTokensDefault: 'Aylık Varsayılan Maksimum Belirteç',
      maxTokensOverride: 'Aylık Maksimum Belirteç Geçersiz Kılma',
      noData: 'Uygun yapılandırma verisi yok.'
    },
    errors: {
      maxFileSizeExceeded: 'Dosya, Bilgi Bankası için belirlenen dosya boyutu sınırını aşıyor.',
      maxTokensExceeded: 'Belirteç sınırına ulaştınız.',
      pageNavigationFailed: 'Sayfaya gidilemedi.'
    },
    feedback: {
      prompt: 'Bildiriminiz için teşekkürler. Bu cevaptaki sorun neydi?',
      reasons: {
        hardToUnderstand: 'Anlaşılması zordu',
        incorrect: 'Yanlıştı',
        missingInfo: 'Bilgiler eksikti',
        offTopic: 'Konu dışıydı'
      },
      submitted: 'Geri bildiriminiz gönderildi.'
    },
    library: {
      buttonText: 'Yapay Zekaya Sor',
      disclaimer: 'Documoto AI hata yapabilir. Cevapların doğruluğunu kontrol edin.',
      inputPlaceholder: 'Bir soru sorun...',
      noContent: 'Bu belge için uygun bağlam yok.',
      promptDefault: 'Sorular sadece bu belgeden yanıtlanır. Sorularınızı teker teker sorun.',
      reference: 'PDF referansı',
      serviceError: 'Bağlam oluşturulurken hata oluştu.',
      title: 'Yapay Zeka Destekli Arama'
    },
    tenantKnowledgeBase: 'Kullanıcı Bilgi Bankası',
    usage: {
      inputTokens: 'Toplam Girdi Belirteçleri',
      noData: 'Uygun kullanım verisi yok.',
      outputTokens: 'Toplam Çıktı Belirteçleri',
      title: 'Belirteç Kullanımı Özeti',
      totalTokens: 'Kullanılan Toplam Belirteç'
    }
  },
  koreanDescription: 'Korece Açıklama',
  koreanName: 'Korece Ad',
  label: 'Etiket | Etiketler',
  labelKey: 'Etiket Anahtarı',
  landscape: 'Yatay',
  laneConfiguration: 'Yol Yapılandırması',
  language: 'Dil',
  largePDFDownloadWarning: 'PDF dosyasının büyük boyutlu olması nedeniyle uygulama içerisinde yükleme ve görüntüleme işlemleri normalden daha uzun sürebilir. Dosya, görüntüleme amacıyla indirilirken lütfen bekleyin.',
  lastGenerated: 'En Son Oluşturulan',
  lastModifiedDate: 'Son Değiştirilme Tarihi',
  lastName: 'Soyadı',
  lastNameEmpty: 'Soyadı boş bırakılamaz',
  lastUpdatedOn: 'Son güncelleme tarihi',
  layout: 'Düzen',
  layoutOptions: 'Düzen Seçenekleri',
  ledger: 'Kayıt Defteri',
  left: 'Sol',
  legal: 'Yasal',
  letter: 'Harf',
  library: 'Kitaplık',
  libraryAdmin: 'Kitaplık Yöneticisi',
  libraryBannerLogo: 'Kitaplık Başlığı Logosu',
  librarySettings: 'Kitaplık Ayarları',
  librarySettingsDescription: 'Bu ayarlar çeşitli Kitaplık ögelerini ve seçeneklerini kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Hizmetleri ile iletişime geçin.',
  licenseConfiguration: 'Lisans Yapılandırması',
  line: 'Satır',
  lineTool: 'Çizgi Aracı',
  link: 'Bağlantı | Bağlantılar',
  listBox: 'Liste Kutusu',
  listBoxValue: 'Liste Kutusu Değeri | Liste Kutusu Değerleri',
  listValue: 'Liste Değeri | Liste Değerleri',
  load: 'Yükle',
  loadMore: 'Daha fazla yükle',
  loading: 'Yükleniyor',
  loadingParts: 'Parçalar Yükleniyor',
  locale: 'Yerel',
  logiReportName: 'Logi Raporu Adı',
  logiReportToggle: 'Logi Raporu mu?',
  login: 'Oturum Aç',
  loginBackground: 'Oturum Açma Arka Planı',
  loginGDPRMessageBeginning: 'Bu web sitesinde çerezler kullanılmaktadır. Bu web sitesini kullanmaya devam ederek çerezlerin kullanılmasına onay vermiş olursunuz. Daha fazla bilgi için bkz. ',
  loginGDPRMessageEnd: 've bkz.',
  loginSSO: 'SSO Oturumu Aç',
  logo: 'Logo | Logolar',
  logout: 'Oturumu Kapat',
  lookupLoadParts: 'Documoto İçe Aktarma´dan Parça Ara/Yükle',
  lowerBound: 'Alt Sınır',
  mOfNShown: '{m}/{n} gösteriliyor',
  mToM: 'M2M',
  mainInfo: 'Ana Bilgi',
  mainLogo: 'Ana Logo',
  makePagesDivisibleBy: 'Sayfaları Bölünebilir Yap:',
  manageItem: '{item} ögesini yönet',
  management: 'Yönetim',
  manuallyResetPassword: 'Parolayı Manuel Olarak Sıfırla',
  manuallySetPassword: 'Parolayı Manuel Olarak Ayarla',
  march: 'Mart',
  margin: 'Marj | Marjlar',
  markdown: 'Alt İşaret',
  maxCharHelpMessage: 'Maksimum karakter sınırı için {min} ile {max} karakter arasında bir değer belirleyin.',
  maxCharacters: 'Maks. Karakter',
  may: 'Mayıs',
  media: 'Medya | Medya',
  mediaBookDeleteMessage: 'Bu medyanın silinmesi, hem Kitaplık hem de İçerik Yöneticisi’ndeki içeriğe erişimi kaldıracaktır ve kullanıcılar ya da İçerik Yöneticileri için bundan böyle erişilebilir olmayacak. Bu kitapta bulunan ancak diğer kitaplarda bulunmayan herhangi bir parça ya da sayfa Kitaplık’da da bulunmayacak.',
  mediaCategory: 'Medya Kategorisi | Medya Kategorileri',
  mediaCategoryEditor: 'Medya Kategorisi Düzenleyici',
  mediaCategoryName: 'Medya Kategorisi Adı',
  mediaCategoryNameMissing: 'Tüm medya kategorileri için bir ad gereklidir',
  mediaDeleteMessage: 'Bu şablonun silinmesi, bunu İçerik Yöneticisinden kaldıracak ve Yeni Medya’ya kopyalanmak için de erişilebilir olmayacak.',
  mediaDeleteSuccessText: 'Endeksleme tamamlandığında listelerden kaldırılacaktır.',
  mediaDescription: 'Medya Tanımı',
  mediaIdentifier: 'Medya Tanımlayıcısı',
  mediaIdentifierDescription: 'Son kullanıcıların araması için dahili medya numarası',
  mediaName: 'Medya Adı',
  mediaPrintSettingsSaveSuccess: 'Medya Yazdırma Ayarları kaydedildi',
  mediaWhereUsed: 'Kullanıldığı Ortam',
  menu: 'Menü',
  merge: 'Birleştir',
  mergeOrOverrideMessage: 'Bu ögelerin üzerine yazmak veya ögeleri birleştirmek ister misiniz?',
  mergeWarning: 'İçeri veri aktarmak mevcut parçaları günceller ve yeni girişler ekler',
  message: 'İleti',
  messageLevel: 'Mesaj Düzeyi',
  messageMessage: 'Bir ileti gerekli',
  metadata: 'Meta Veri',
  microsite: 'Mikrosite | Mikrositeler',
  micrositeAdmin: {
    cardSubtitle: 'Sıkıştırılmış içerik dosyası ve HTML giriş bilgileri',
    cardTitle: 'Site İçeriği',
    errorRequiredFile: 'Bir Site İçeriği ZIP dosyası gereklidir',
    fieldFile: 'Site İçeriği ZIP Dosyası',
    fieldPoint: 'HTML Giriş Noktası'
  },
  minArea: 'Minimum Alan',
  minAreaMessage: 'Minimum değer gerekiyor. Değer 1 ila 1500 aralığını aşamaz.  Bir tamsayı değeri olmalıdır.',
  minCharacters: 'Min. Karakter',
  minMaxCharHelpMessage: 'Maksimum karakter sınırı için {min} ile {max} karakter arasında bir değer belirleyin. Maks. değeri, Min değerinden büyük ya da aynı olmalıdır.',
  mine: 'Benim',
  miscellaneous: 'Çeşitli',
  mon: 'Pzt',
  month: 'Ay',
  moreInfo: 'Daha Fazla Bilgi',
  multipleAlternatingPages: 'Birden Çok Değişimli Sayfa',
  multipleAlternatingPagesMessage: '1. ve 3. sayfalarda diyagram, 2. ve 4. sayfalarda parça listesi',
  multiplePages: 'Birden Fazla Sayfa',
  multiplePagesMessage: 'Diyagram kendi sayfasında ve ardından parça listesi sayfaları',
  myCart: 'Sepetim | Sepetlerim',
  nItemsCreated: '{n} {items} Oluşturuldu',
  nItemsDeleted: '{n} {items} Silindi',
  nOfMItems: '{n} / {m} {items}',
  name: 'Ad',
  nameDescriptionHelpText: 'İsim ve isteğe bağlı açıklama',
  navigation: 'Navigasyon',
  'new': 'Yeni',
  newAPIKey: 'Yeni Uygulama Programı Arabirimi Anahtarı',
  newERPSystem: 'Yeni ERP Sistemi',
  newItem: 'Yeni {item}',
  newKeyGenerated: 'Yeni Entegrasyon Anahtarı Oluşturuldu, gelecekte kullanmak üzere Kopyalayın ve Saklayın',
  newMediaCategory: 'Yeni Medya Kategorisi',
  newPassword: 'Yeni Parola',
  newTenant: 'Yeni Kiracı',
  newWidgetKey: 'Yeni Widget Anahtarı',
  newWidgetKeyGenerated: 'Yeni Widget Anahtarı oluşturuldu, sonraki kullanım için Kopyala ve Sakla',
  newsItem: 'Haber Ögesi | Haber Ögeleri',
  noAPIKeys: 'Tanımlı Uygulama Programı Arabirimi Anahtarı yok.',
  noData: 'Veri Yok',
  noFileSelected: 'Dosya Seçilmedi',
  noFilesSelected: 'Dosya Seçilmedi',
  noFormsMessage: 'Tanımlı Form yok.',
  noIllustrationFound: 'Çizim Bulunamadı',
  noImageFound: 'Resim Bulunamadı',
  noItemAddedToTarget: '{target} için eklenen {item} yok. ',
  noItemAvailable: '{item} yok',
  noItemFound: '{item} öge bulunamadı.',
  noItemSelected: 'Hiçbir {item} seçilmedi',
  noItemsFound: 'Öge Bulunamadı',
  noMediaDefined: 'Tanımlı Medya yok',
  noMoreResults: 'Başka sonuç yok',
  noPartCollectionsFound: 'Hiç {partCollection} bulunamadı.',
  noPartsSelected: 'Hiçbir parça seçilmedi.',
  noPrice: 'Fiyat İste',
  noResults: 'Sonuç yok',
  noSearchResultsHelpText: 'Hiç sonuç bulunamadı',
  noSearchableCategories: 'Aranabilir kategori yok',
  noSearchableTags: 'Aranabilir etiket yok',
  noSuggestions: 'Arama terimi için öneri bulunamadı',
  noSupercedingPartsFoundForPartNumber: 'Bu parça numarasının yerine geçecek parça bulunamadı.',
  noTagsFound: 'Etiket Bulunamadı',
  noTenantSuppliers: 'Kiracıya atanmış Sağlayıcı yok.',
  noUnsavedChanges: 'Kaydedilmemiş Değişiklik Yok',
  noWidgetKeys: 'Tanımlanmış Widget Anahtarı yok.',
  node: 'Düğüm',
  nonSearchableFieldsSuccessfullyUpdated: 'Aranamaz Alanlar Başarıyla Güncellendi.',
  none: 'Hiçbiri',
  norwegianDescription: 'Norveççe Açıklama',
  norwegianName: 'Norveççe Ad',
  notAvailable: 'Yok',
  notImplemented: 'Uygulanmadı',
  notMapped: 'Eşlenmedi',
  notOrderable: 'Sipariş Verilemez',
  notSelected: 'Seçili değil',
  notification: 'Bildirim | Bildirimler',
  notificationsMessage: 'Önemli duyurular ve haberler',
  november: 'Kasım',
  numberOf: '# / {item}',
  numeric: 'Sayısal',
  october: 'Ekim',
  of: '/',
  off: 'Kapalı',
  offlineContent: 'Çevrim Dışı İçerik',
  ok: 'Tamam',
  oldPassword: 'Eski Parola',
  on: 'Açık',
  opacity: 'Opaklık',
  open: 'Aç',
  openItem: '{item} ögesini aç',
  openTab: 'Bağlantıyı başka bir sekmede aç',
  optimizeIndexJob: 'Dizini İyileştir',
  optionalConfiguration: 'İsteğe Bağlı Yapılandırma | İsteğe Bağlı Yapılandırmalar',
  options: 'Seçenekler',
  order: 'Sipariş | Siparişler',
  orderAttachmentHelpText: 'Her biri en fazla 50 MB olacak şekilde en fazla 10 dosya yükleyebilirsiniz. İzin verilen dosya türleri: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Sipariş Tarihçesini Devre Dışı Bırakın',
  orderEmailRecipient: 'Sipariş E-postası Alıcısı | Sipariş E-postası Alıcıları',
  orderEntity: 'Sipariş Varlığı | Sipariş Varlıkları',
  orderField: {
    nameMessage: 'Sipariş/Teklif Alanı adını değiştirirseniz bu alanı kullanan tüm Sipariş/Teklif Formlarını veya E-posta Biçimlerini güncellediğinizden emin olun.'
  },
  orderFieldCopyMessage: 'Yeni Sipariş/Teklif Alanı için benzersiz bir ad girin',
  orderFieldUneditableRequired: 'Bir Sipariş/Teklif Alanının Gerekli olarak ayarlanması ve Kullanıcı Tarafından Düzenlenebilir olmaması, Sipariş/Teklif Formunuzun doldurulmasını imkansız hâle getirebilir. Lütfen Sipariş/Fiyat Teklifi Formlarınızın doldurulabildiğini doğrulayın.',
  orderFieldsEmptyMessage: 'Tanımlı Sipariş/Teklif Alanı yok.',
  orderFieldsEmptyPrompt: 'Sipariş/Teklif Alanı Ekle',
  orderForm: {
    uniqueNameInputHint: 'Yeni Form için benzersiz bir ad girin.'
  },
  orderFormField: 'Sipariş/Fiyat Teklifi Alanı | Sipariş/Fiyat Teklifi Alanları',
  orderFormLayout: 'Sipariş/Teklif Formu Düzeni | Sipariş/Teklif Formu Düzenleri',
  orderFormSetDefault: 'Varsayılan Sipariş/Teklif Formu ayarlandı',
  orderFormType: 'Sipariş Formu',
  orderLayout: 'Sipariş Düzeni | Sipariş Düzenleri',
  orderManagementApprover: 'Sipariş Yönetimi Onaylayıcısı',
  orderManagementDisable: 'Sipariş Yönetimi Yöneticisini Devre Dışı Bırak',
  orderManagementViewer: 'Sipariş Yönetimi Görüntüleyicisi',
  orderNumber: 'Sipariş Numarası',
  orderQuoteDeleteWarning: 'Bir sipariş veya fiyat teklifi formuna uygulanan, bir e-posta şablonunda kullanılan veya daha önce gönderilen siparişlerde veya fiyat tekliflerinde kullanılan alanlar silinemez.',
  orderQuoteEmail: 'Sipariş/Teklif E-postası | Sipariş/Teklif E-postaları',
  orderQuoteEmailFormat: 'Sipariş/Teklif E-posta Formatı | Sipariş/Teklif E-posta Formatları',
  orderQuoteEmailFormatCopyMessage: 'Yeni Sipariş/Teklif E-posta Formatı için bir dil seçin.',
  orderQuoteFetchError: 'Sipariş/Teklif Formu verileri alınırken hata oluştu',
  orderQuoteForm: 'Sipariş/Fiyat Teklifi Formu | Sipariş/Fiyat Teklifi Formları',
  orderQuoteFormSaved: 'Sipariş/Teklif Formu Kaydedildi',
  orderQuoteSaveConfirmation: 'Organizasyon Sipariş/Teklif formlarında yaptığınız değişiklikleri kaydet?',
  orderQuoteSaveError: 'Sipariş/Teklif Formu verileri kaydedilirken hata oluştu',
  orderStatus: 'Sipariş/Teklif Durumu | Sipariş/Teklif Durumları',
  orderStatusDeleteMessage: 'Bu durum siparişlerde kullanılmıştır ve silinemez.',
  orderSubmittedMessage: 'Başarılı Şekilde Gönderildi',
  orderSuggestion: 'Sipariş Önerisi | Sipariş Önerileri',
  orderSuggestionEnable: 'Sipariş Önerilerini Etkinleştir',
  orderSuggestionRemovalWarning: 'Parça artık bir sipariş önerisi olarak gösterilmeyecek. | Parçalar artık sipariş önerileri olarak gösterilmeyecek.',
  orderSuggestionThreshold: 'Sipariş Önerisi Eşiği',
  orderable: 'Sipariş edilebilir',
  orderableDescription: 'Sepetinize parça eklenebilir ve satın alınabilir',
  orderableLocal: 'Bu sayfadan sipariş edilebilir',
  orderableLocalBlocked: 'Parça Global Olarak Sipariş Edilemiyor',
  ordersLogo: 'Siparişler Logosu',
  ordersMessage: 'Sipariş gönderme geçmişi',
  org: 'Organizasyon',
  orgAccessControlsWarning: 'Not: Üst kuruluşlar (örneğin, ana kuruluşlar veya üst kademe kuruluşlar), alt kuruluşlara (örneğin, bağlı kuruluşlar veya iştirakler) atanan içeriklere otomatik olarak erişim hakkı elde eder.',
  orgEmailRecipients: 'Kuruluş E-posta Alıcıları',
  orgNameOnly: 'Yalnızca Organizasyon Adı',
  organization: 'Kuruluş| Kuruluşlar',
  organizationAdmin: 'Kuruluş Yöneticisi',
  organizationAdminBrowseFlow: 'Bir Kuruluş, varsayılan göz atma akışını kullanabilir veya siz diğer herhangi bir göz atma akışını geçersiz kılabilir ve kullanabilirsiniz.',
  organizationAdminMessage: 'Kullanıcı yönetimi ve kuruluş ayarlarını kontrol eder',
  organizationEmailRecipients: 'Kuruluş E-posta Alıcıları',
  organizationEmpty: 'Kuruluş seçilmelidir',
  organizationEnforceAccessControlsForQuickAdd: 'Hızlı Ekleme için Erişim Denetimlerini Zorla',
  organizationKey: 'Kuruluş Anahtarı',
  organizationLibrarySettingsDescription: 'Bu ayarlar, Kuruluş düzeyindeki çeşitli Kitaplık ögelerini ve seçeneklerini kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Hizmetleri ile iletişime geçin.',
  organizationMoveToRoot: 'Kök dizine taşımak için buraya bırakın',
  organizationName: 'Kuruluş Adı',
  organizationRearrange: 'Kuruluşları Yeniden Düzenleyin',
  organizationRearrangeDescription: 'Hiyerarşi bakımından alt ve üst Kuruluş yapısı, Yazdırma Ayarları, Stiller ve diğerleri gibi bir Kuruluşun miras alınabilen birçok özelliğini tanımlar. İstenen hiyerarşiyi yansıtmak için Kuruluşları sürükleyip bırakın.',
  organizationReportSettingsSuccessMessage: 'Rapor ayarları kaydedildi',
  organizationSelect: 'Kuruluş Seçin',
  organizationTags: 'Kuruluş Etiketleri',
  organizationsEmpty: 'Görünüşe göre henüz bir kuruluş oluşturmadınız',
  orientation: 'Yön',
  other: 'Diğer',
  otherSettings: 'Diğer Ayarlar',
  outboundCustomerIdParameter: 'Giden Müşteri Kimliği Parametre Adı',
  outboundSessionIdParameter: 'Giden Oturum Kimliği Parametre Adı',
  outlineMode: 'Dış Hat Modu (Shift O)',
  output: 'Çıkış',
  outputCatalog: 'Çıkış Kataloğu',
  outputDefinition: 'Çıkış Tanımı | Çıkış Tanımları',
  outputDefinitionDeleted: 'Çıkış Tanımı silindi',
  outputDefinitionSaved: 'Çıkış Tanımı Kaydedildi',
  outputDestination: 'Çıktı Hedefi',
  outputFileName: 'Çıkış Dosyası Adı',
  outputName: 'Çıkış Adı',
  outputSpecification: 'Çıkış Belirtimi',
  outputSubType: 'Çıkış Alt Türü',
  outputType: 'Çıkış Türü',
  overridden: 'Geçersiz Kılındı',
  overriddenByOrg: 'Kuruluş tarafından geçersiz kılındı',
  override: 'Geçersiz Kıl',
  overrideBrowseFlow: 'Göz Atma Akışını Geçersiz Kıl',
  overrideFacetLimitValue: 'Özellik Limit Değerini Geçersiz Kıl',
  overrideFontSettings: 'Font Ayarlarını Geçersiz Kıl',
  overrideHotpointScale: 'Hotpoint Ölçeğini Geçersiz Kıl',
  overrideOrderForm: 'Sipariş Formunu Geçersiz Kıl',
  overridePdfNamingStandard: 'PDF Dosya Adlandırma Standardını geçersiz kıl',
  overridePrintSettings: 'Yazdırma Ayarlarını Geçersiz Kıl',
  overrideQuoteForm: 'Teklif Formunu Geçersiz Kıl',
  overrideSvgOpacity: 'SVG Opaklığını Geçersiz Kıl',
  overrideWarning: 'İçeri veri aktarmak mevcut Malzeme Listenizi değiştirir',
  owner: 'Sahibi | Sahipleri',
  page: 'Sayfa | Sayfalar',
  pageBomPartsDeleted: 'Malzeme Listesi sayfası üzerindeki {count} parça {filename} ile erişilebilir olmayacak.',
  pageBuilder: 'Sayfa Oluşturucu',
  pageBulkErrorTooManyBooks: 'Seçili kitap sayısını en fazla 1000 ile sınırlayın',
  pageBulkInsertBooksConfirmInsertAfter: 'Bu işlem {whereUsedBookCount} {bookUnits} içinde {original} ögesinden sonra {replacement} ögesini ekleyecektir.',
  pageBulkInsertBooksConfirmInsertBefore: 'Bu işlem {whereUsedBookCount} {bookUnits} içinde {original} ögesinden önce {replacement} ögesini ekleyecektir.',
  pageBulkInsertBooksConfirmInsertReplace: 'Bu işlem {whereUsedBookCount} {bookUnits} içinde {original} ögesini kaldırıp {replacement} ögesini ekleyecektir.',
  pageBulkInsertConfirmInsertAfter: 'Bu işlem {whereUsedBookCount} {bookUnits} ve {whereUsedTemplateCount} {templateUnits} içinde {original} ögesinden sonra {replacement} ögesini ekleyecektir.',
  pageBulkInsertConfirmInsertBefore: 'Bu işlem {whereUsedBookCount} {bookUnits} ve {whereUsedTemplateCount} {templateUnits} içinde {original} ögesinden önce {replacement} ögesini ekleyecektir.',
  pageBulkInsertConfirmInsertReplace: 'Bu işlem {whereUsedBookCount} {bookUnits} ve {whereUsedTemplateCount} {templateUnits} içinde {original} ögesini kaldırıp {replacement} ögesini ekleyecektir.',
  pageBulkInsertConfirmTitle: 'Toplu ekleme işlemini tamamlamak istiyor musunuz?',
  pageBulkInsertDiscard: 'Toplu girişiniz işleme alınmayacaktır.',
  pageBulkInsertHelpText: 'Bu özellik, bu kaynak sayfayı {thisDisplayName}, zaten var olan başka bir sayfanın {originalDisplayName} seçili parça kitaplarına eklemenizi sağlar. İsteğe bağlı olarak {originalDisplayName} o kitaplardan çıkarılabilir.',
  pageBulkInsertInsertAfter: '{original} SONRASINDA {replacement} ekle',
  pageBulkInsertInsertBefore: '{original} ÖNCESİNDE {replacement} ekle',
  pageBulkInsertInsertReplace: '{replacement} ekle ve {original} olanı KALDIR',
  pageBulkInsertScopeAll: '{originalDisplayName} ({whereUsedCount} {units}) hedef sayfasına sahip tüm {type} ögeleri.',
  pageBulkInsertScopeNone: '{originalDisplayName} hedef sayfasına sahip hiçbir {type} ögesi',
  pageBulkInsertScopeSome: '{originalDisplayName} hedef sayfasına sahip bazı {type} ögeleri',
  pageBulkInsertStep1: '1. Adım: İstenilen bir hedef sayfayı bulun ',
  pageBulkInsertStep2: '2. Adım: Sayfaların nasıl ekleneceğine veya değiştirileceğine karar verin',
  pageBulkInsertStep3: '3. Adım: Toplu eklemenin işlenmesini istediğiniz kitapları seçin.',
  pageBulkInsertStep4: '4. Adım: Toplu eklemenin işlenmesini istediğiniz şablonları seçin.',
  pageBulkInsertSuccessBody: 'Kitap içindekiler tablosu değişiklikleri hemen yapılacaktır. Endeksleme tamamlandığında arama sonuçları yansıtılacaktır.',
  pageBulkInsertSuccessTitle: 'Toplu giriş işi gönderildi',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Bu işlem {whereUsedTemplateCount} {templateUnits} içinde {original} ögesinden sonra {replacement} ögesini ekleyecektir.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Bu işlem {whereUsedTemplateCount} {templateUnits} içinde {original} ögesinden önce {replacement} ögesini ekleyecektir.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Bu işlem {whereUsedTemplateCount} {templateUnits} içinde {original} ögesini kaldırıp {replacement} ögesini ekleyecektir.',
  pageComposer: 'Page Composer',
  pageCreated: 'Sayfa Oluşturuldu',
  pageDeleteMessage: 'Sayfa silmeleri, Kütüphane ve İçerik Yöneticisi içinde anında gerçekleşir. Silinen sayfalar, birkaç dakika içinde tekrar dizinlenene kadar aranabilir.',
  pageDeleteMessage2: 'Bu eylem, Documoto Destek yardımı olmadan geri alınamaz. 90 gün sonra silinen kayıt ve tüm bileşenleri kalıcı olarak silinir.',
  pageDescription: 'Sayfa Tanımı',
  pageDraftsDeleted: 'Bu sayfayla ilişkili taslak sayfalar kalıcı olarak silinir.',
  pageFile: 'Sayfa Dosyası',
  pageFileRequired: 'Bir sayfa dosyası gerekli.',
  pageFilename: 'Sayfa Dosya Adı',
  pageFilenameDeleted: '{filename} silinecek.',
  pageFit: 'Sayfaya Sığdır',
  pageHeader: 'Sayfa Başlığı',
  pageLabel: 'Sayfa | Sayfalar',
  pageLayout: 'Sayfa Düzeni',
  pageName: 'Sayfa Adı',
  pagePart: 'Sayfa Bölümü | Sayfa Bölümleri',
  pagePartData: 'Sayfa Bölümü Verileri',
  pagePartLevelDetails: 'Sayfa Bölümü Sipariş Edilebilir/Görünür, Sayfa Bölümü Etiketleri',
  pagePartNumberVisible: 'Sayfa Parça Numarası Görülebilir',
  pagePartOrderable: 'Sayfa Parçası Sipariş Edilebilir',
  pagePartOrderableDescription: 'Parça bu sayfadan Sipariş Edilebilir',
  pagePartTag: 'Sayfa Parça Etiketi | Sayfa Parça Etiketleri',
  pagePartVisibleDescription: 'Parça Numarası bu sayfada görünebilir',
  pageToPartCollectionFailure: '{name} Sayfası bir Parça Koleksiyonu olarak eklenemedi.',
  pageUpdated: 'Sayfa Güncellendi',
  pageUsageDataCouldNotBeLoaded: 'Sayfa Kullanım Verileri Yüklenemedi',
  pageViewer: 'Sayfa Görüntüleyici',
  pageWidth: 'Sayfa Genişliği',
  pagesWhereUsed: 'Kullanıldığı Sayfalar',
  parentName: 'Ana Kuruluş Adı | Ana Kuruluş Adları',
  part: 'Parça | Parçalar',
  partCode: 'Parça Kodu | Parça Kodları',
  partCodeAddError: 'Parça Kodu/Kodları eklenemiyor',
  partCodeErrorEmpty: 'Kaydedilemedi: Parça kodu boş olamaz',
  partCodeErrorInUse: 'Bu parça kodu Documoto`da parçalar tarafından kullanılıyor ve silinemez. Yardım için support{\'@\'}documoto.com adresinden Documoto Destek Merkezi ile iletişime geçin.',
  partCodeErrorNotFound: 'Bulunamadığı için bu parça kodları silinemedi, lütfen tüm değişikliklerin kaydedildiğinden emin olun.',
  partCodesManager: 'Parça Kodları Yöneticisi',
  partCodesMessage: 'Parça kodları parça numaraları yerine kullanılabilir ve genellikle ürün ağacı ögelerinin ne zaman kullanılmadığını, kullanılamadığını veya yalnızca referans ögeleri olduğunu gösterir (örn. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Parça Koleksiyonu | Parça Koleksiyonları',
  partCollectionsDescription: 'Bu {productPage} üzerinde {collections} olarak görüntülenmek üzere en fazla 20 {parts} {pages} ekleyin.',
  partCollectionsDescription2: 'Seçilen {collections}, hangi {parts}ın hızlı erişim veya sipariş için kullanıcılara açık olacağını tanımlar.',
  partCollectionsDescription3: 'Aşağıda tanımlanan sıralama, bunların Kitaplık {productPage} Görüntüleyici’de nasıl görüneceğini belirler.',
  partCollectionsLimitError: 'Her {item2} başına en fazla {limit} {item1} eklenebilir.',
  partCreated: 'Parça Oluşturuldu',
  partData: 'Parça Verileri',
  partDebouncerEmailQueueJob: 'Eposta Kuyruğu',
  partDescription: 'Parça Tanımı',
  partEquipmentVerificationBanner: 'Parça Ekipman Doğrulama Banner\'i',
  partLabel: 'Parça | Parçalar',
  partLevelDetails: 'Bölüm Fiyatlandırması, Sipariş Edilebilir/Görünür, Ek Çeviriler, Bölüm Etiketleri',
  partName: 'Parça Adı',
  partNumber: 'Parça Numarası',
  partNumberCopied: '{label} panoya kopyalandı',
  partNumberDescription: 'Son kullanıcıların araması için dahili parça numarası',
  partNumberSupercededBy: '{partNumber} aşağıdakinin bir SupersededPartNumber etiketi olarak mevcut...',
  partNumberVisible: 'Görülebilir Parça Numarası',
  partNumberVisibleDescription: 'Parça numarası son kullanıcılar tarafından görülebilir',
  partNumberVisibleLocal: 'Bu sayfada görülebilir',
  partNumberVisibleLocalBlocked: 'Parça Numarası Global Olarak Görünmüyor',
  partOrderable: 'Parça Sipariş Edilebilir',
  partRequired: 'En az bir parça gerekli',
  partTag: 'Parça Etiketi | Parça Etiketleri',
  partTagProperty: 'Parça Etiketi Özelliği | Parça Etiketi Özellikleri',
  partUpdated: 'Bölüm Güncellendi',
  partVerificationInstructions: 'Bu parçanın ekipmanınıza uygun olduğunu doğrulayın',
  partialSupport: 'Kısmi Destek',
  partnerApiKey: 'Partner Uygulama Programı Arabirimi Anahtarı',
  partnerRESTRequestLimit: 'Partner REST Talebi Limiti',
  partsBook: 'Parça Defteri | Parça Defterleri',
  partsBulkImport: {
    description: 'Parçaları toplu içe aktarma işlemine göndermek için veri dosyanızı yükleyin. Desteklenen dosya formatı: XLSX.',
    downloadTemplate: 'XLSX şablonunu indirin',
    downloadUnprocessedRows: 'İşlenmemiş Satırlar Elektronik Tablosunu İndirme',
    hideRequirements: 'XLSX gereksinimlerini gizleyin',
    overwriteTagValues: 'Eşleşen etiketler için etiket değerlerinin üzerine yazın',
    overwriteTranslations: 'Eşleşen çevirilerin üzerine yazın',
    requirements: {
      discountPrice: {
        description: 'Kiracı düzeyindeki indirimli fiyatı belirler.'
      },
      enUSDescription: {
        description: 'Bir parça için dile özgü çeviri açıklaması. <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Dil Desteği Kılavuzumuza</a> başvurun.'
      },
      enUSName: {
        description: 'Bir parça için dile özgü çeviri adı. Yeni parçalar için en az bir çeviri zorunludur. <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Dil Desteği Kılavuzumuza</a> başvurun.'
      },
      orderable: {
        description: 'Parçanın sipariş edilip edilemeyeceğini belirler. `true` veya `false` değerlerine izin verilir. Varsayılan, `true` değeridir.'
      },
      orgDiscountPrice: {
        description: 'Tanımlı bir kuruluş için kuruluş düzeyindeki indirimli fiyatı belirler. Başlık örneği: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Tanımlı bir kuruluş için kuruluş düzeyindeki perakende fiyatını belirler. Başlık örneği: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Tanımlı bir kuruluş için kuruluş düzeyindeki toptan fiyatı belirler. Başlık örneği: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Parçanın benzersiz tanımlayıcısı.'
      },
      retailPrice: {
        description: 'Kiracı düzeyindeki perakende fiyatı belirler.'
      },
      supplier: {
        description: 'Parça tedarikçisinin adı.'
      },
      tagInternalName: {
        description: 'Etiketleri parçayla ilişkilendirir. Birden fazla değer kullanacaksanız her birini &#124; ile ayırın. Örnek: Kırmızı&#124;Yeşil&#124;Mavi.'
      },
      thumbnail: {
        description: 'Küçük resim dosya adı. İzin verilen uzantılar: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Ölçü birimi (ör. "adet", "birim").'
      },
      visible: {
        description: 'Parçanın görünür olup olmadığını belirler. `true` veya `false` değerlerine izin verilir. Varsayılan, `true` değeridir.'
      },
      wholesalePrice: {
        description: 'Kiracı düzeyindeki toptan fiyatı belirler.'
      }
    },
    showRequirements: 'XLSX gereksinimlerini görüntüleyin',
    submitNote: '"Gönder" seçeneğine tıkladığınızda, bir arka plan işi başlatılır ve "İş Yöneticisi" sayfasına yönlendirilirsiniz.',
    success: 'Parçaları toplu içe aktarma işi oluşturuldu',
    title: 'Parçaları Toplu İçe Aktarma'
  },
  partsColumns: 'Parça Sütunları',
  partsDisplay: 'Parça Ekranı',
  partsList: 'Parçalar Listesi',
  partsListColumn: 'Parça Listesi Sütunu | Parça Listesi Sütunları',
  partsListData: 'Parça Listesi Verileri',
  partsListGridHeader: 'Parça Listesi Tablo Başlığı',
  partsNotSelected: 'Parça küçük resimleri için kullanılan varsayılan resim. Özel bir küçük resim uygulanmazsa, Documoto standart bir varsayılan küçük resim görüntüler.',
  partsPage: 'Parçalar Sayfası | Parçalar Sayfaları',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Parça sütunları yüklenemedi',
    columnsUpdateErrorMsg: 'Parça Sütunlarını güncellemeye çalışırken bir hata oluştu',
    columnsUpdateSuccessMsg: 'Parça Sütunları güncellendi',
    cropWhitespaceOnImages: 'Görsellerde Beyaz Boşluğu Kırpma',
    excludePartCodesFromPartsLists: 'Parça Kodlarını Parça Listelerinden Çıkar',
    highlightAlternateRows: 'Değişimli Satırları Vurgula',
    keepBOMOnRight: 'Malzeme Listesini Sağda Tut',
    keepImagesOnLeft: 'Görüntüleri Solda Tut',
    printBorderAroundImages: 'Görüntülerin Çevresinde Yazdırma Kenarı',
    printHotpointsOnImages: 'Resimlere Etkin Noktaları Bas',
    rotateImagesAutomatically: 'Görüntüleri Otomatik Olarak Döndür'
  },
  partsPages: 'Parça Sayfaları',
  password: 'Parola',
  passwordBlankMessage: 'Parola boş bırakılamaz',
  passwordCannotBeSame: 'Mevcut parolanızla aynı olamaz',
  passwordCasingMassage: 'En az bir küçük harf ve bir büyük harf içermelidir',
  passwordCriteriaInfo: 'Yeni parolanız şu kriterleri karşılamalıdır:',
  passwordExpiredHeader: 'Parola Süresi Doldu',
  passwordExpiredInfo: 'Parolanızın süresi dolmuştur. Yeni parolanız şu kriterleri karşılamalıdır:',
  passwordLowerCaseMessage: 'Parola en az bir küçük harf karakter içermelidir',
  passwordMinLengthMessage: 'Parola en az 8 karakter uzunluğunda olmalıdır',
  passwordNotMatchingMessage: 'Parolalar aynı değil',
  passwordOptions: 'Parola Seçenekleri',
  passwordOptionsRequired: 'Parola Seçenekleri boş bırakılamaz',
  passwordSpecialCharactersMessage: 'Parola en az bir özel karakter içermelidir',
  passwordUpperCaseMessage: 'Parola en az bir büyük harf karakter içermelidir',
  passwordWillExpire1Day: 'Giriş Parolasının süresi 1 günden daha kısa süre içinde dolacaktır',
  passwordWillExpire5Days: 'Giriş Parolasının süresi 5 günden daha kısa süre içinde dolacaktır',
  passwordsMatch: 'Şifreler Eşleşiyor',
  pdfImport: {
    aiPdfImports: 'AI PDF İçe Aktarımları',
    aiPdfImportsDescription: 'Otomatik içerik işleme için AI PDF içe aktarımlarını yönetin.',
    createImport: 'Yeni AI PDF İçe Aktarımı',
    createImportDescription: 'Bir PDF kaynak dosyası seçin ve veri ayıklama ayarlarını yapılandırın. Dosya sınırlamaları: en fazla 500 MB dosya boyutu ve 3000 sayfa.',
    defaultPartNumberCode: 'Varsayılan Parça Numarası Kodu',
    defaultTranslationLocale: 'Varsayılan Çeviri Dili',
    defaultUomHelpText: 'Bir Ölçü Birimi sütunu eşlenmediğinde veya ayıklanmış bir BOM satırı bir Ölçü Birimi değeri sağlamadığında kullanılır.',
    defaultUomRequired: 'Ölçü Birimi sağlanmadığı takdirde zorunludur',
    dropFileMessage: 'Dosyayı buraya sürükleyin veya yüklemek için tıklayın',
    fileSizeError: 'Dosya boyutu 500 MB sınırını aşıyor',
    importCreatedError: 'İçe aktarım oluşturulamadı',
    importCreatedSuccess: 'İçe aktarım başarıyla oluşturuldu ve işleme sırasına alındı',
    mapColumnToTag: 'Sütunu Sayfa Bölümü Etiketiyle Eşle',
    monthlyLimitExceeded: 'Aylık AI PDF İçe Aktarımı sayfa sınırı aşılacak. Yardım almak için Müşteri Başarı Yöneticinizle iletişime geçin.',
    pageNumberFilterInvalidRange: 'Geçersiz sayfa numarası aralığı',
    pageNumberFilterPlaceholder: 'ör. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Parça Numarası Kodu, Parça Numarası değerinin boş olduğu BOM satırları için geçerlidir',
    pdfImport: 'PDF İçe Aktarımı | PDF İçe Aktarımları',
    pdfImportsDescription: 'Parça verilerini PDF belgelerinden otomatik olarak ayıklamak için yapay zeka destekli PDF aktarımlarını yönetin',
    publishModalFooterHelp: '"Yayınla" düğmesine tıkladığınızda, bir arka plan işi sıraya eklenip başlatılır ve siz de yayınlama durumunu takip edebileceğiniz AI PDF İçe Aktarımları yönetim sayfasına yönlendirilirsiniz.',
    publishSkipAutoHotpointing: 'Sayfada otomatik hotpoint oluşturmayı atla | Sayfalarda otomatik hotpoint oluşturmayı atla',
    publishingFinishedNone: '"{importName}" içe aktarımını yayınlama işlemi tamamlandı. Hiçbir sayfa yayınlanmadı.',
    publishingFinishedPartial: '"{importName}" içe aktarımını yayınlama işlemi tamamlandı. {success} sayfa yayınlandı, {failed} sayfa yayınlanamadı. | {importName} içe aktarımını yayınlama işlemi tamamlandı. {success} sayfa yayınlandı, {failed} sayfa yayınlanamadı.',
    publishingFinishedSuccess: '"{importName}" içe aktarımını yayınlama işlemi tamamlandı. {count} sayfa yayınlandı. | {importName} içe aktarımını yayınlama işlemi tamamlandı. {count} sayfa yayınlandı.',
    reviewStatusAll: 'Durum: Tümü',
    reviewStatusApproved: 'Onaylandı',
    reviewStatusDropped: 'Bırakıldı',
    reviewStatusNoStatus: 'Durum Yok',
    reviewStatusNone: 'Hiçbiri',
    reviewStatusPending: 'Beklemede',
    selectPagePartTag: 'Sayfa Bölümü Etiketi Seç',
    statusDeclined: 'Reddedildi',
    statusFailed: 'Başarısız',
    statusPending: 'Beklemede',
    statusProcessing: 'İşleniyor',
    statusPublished: 'Yayınlandı',
    statusPublishing: 'Yayınlanıyor',
    submitNote: '"Gönder" düğmesine tıkladığınızda, bir arka plan işi sıraya eklenip başlatılır ve siz de içe aktarım durumunu takip edebileceğiniz AI PDF İçe Aktarımları yönetim sayfasına yönlendirilirsiniz.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Eşleme Durumu',
    columnPagePartTag: 'Sayfa Bölümü Etiketi',
    columnPartNameWithLocale: 'Parça Adı ({locale})',
    emptyState: 'Hiç BOM ögesi bulunamadı.',
    existingPartNameApplied: 'Mevcut parça verileri uygulandı',
    title: 'Malzeme Listesi'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Çizim Sınırlarını Ayarla',
    boundsAdjusted: 'Sınırlar ayarlandı',
    emptyState: 'Bu sayfada hiç çizim yok.',
    hiresUnavailableError: 'Bu sayfada yüksek çözünürlüklü görüntü yok.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Seçilenleri Onayla ({count})',
    actionClearStatusSelected: 'Seçilenlerin Durumunu Temizle ({count})',
    actionCopySelected: 'İlk Seçilen Sayfayla Birleştir',
    actionDeleteImport: 'AI PDF İçe Aktarımını Sil',
    actionDropSelected: 'Seçilenleri Bırak ({count})',
    actionPendingSelected: 'Seçilenleri Beklemede Olarak Ayarla ({count})',
    actionPublishSelected: 'Seçilenleri Yayınla',
    autoMergeAction: 'Sayfaları Otomatik Birleştir',
    autoMergeConfirmHelp: 'Sayfaları Otomatik Birleştir, aynı sayfa Adına sahip sayfaları bulur ve her eşleşen grubu görsel sıralamasına göre ilk sayfada birleştirir. Bir hedef sayfa oluşturmak üzere birleştirilen kaynak sayfalar, Bırakıldı olarak işaretlenir. Yayınlamadan önce sonuçları gözden geçirin.',
    autoMergeConfirmTitle: 'Aynı ada sahip sayfalar otomatik birleştirilsin mi?',
    autoMergeFailed: 'Otomatik birleştirme başarısız, hiçbir değişiklik yapılmadı',
    autoMergeSuccess: 'Otomatik birleştirme tamamladı: {count} grup birleştirildi, {dropped} sayfa bırakıldı',
    composedPageIndicator: 'Bu sayfada, başka PDF sayfalarından kopyalanmış içerikler bulunuyor.',
    contentTypeAll: 'Tüm İçerik Türleri',
    contentTypeBomOnly: 'Yalnızca BOM',
    contentTypeBoth: 'Hem BOM hem de Çizimler',
    contentTypeEmpty: 'Boş Sayfalar',
    contentTypeFilterLabel: 'İçerik Türü',
    contentTypeIllustrationsOnly: 'Yalnızca Çizimler',
    importSettings: 'İçe Aktarım Ayarları',
    includeDroppedPagesLabel: 'Bırakılan sayfaları dahil et',
    incompleteBomFilterLabel: 'Eksik BOM’a sahip sayfaları göster',
    mergeConfirmSourcePages: '{count} kaynak sayfa seçildi: | {count} kaynak sayfa seçildi:',
    mergeConfirmTitle: 'Seçilen sayfalar ilk seçilen sayfayla birleştirilsin mi?',
    mergeConfirmTarget: 'Hedef Sayfa: {pageLabel}',
    mergeFailed: 'Seçilen sayfalar ilk seçilen sayfayla birleştirilemedi.',
    mergeSuccess: 'Sayfalar {pageLabel} ile birleştirildi ({bomCount} BOM ögesi, {illustrationCount} çizim)',
    noPages: 'Kullanılabilecek sayfa yok',
    noPagesHint: 'Bu içe aktarımda hiç sayfa bulunmuyor',
    noResults: 'Hiç eşleşen sayfa bulunamadı',
    noResultsHint: 'Aramanızı veya filtrelerinizi ayarlamayı deneyin',
    notificationLoadFailed: 'Genel bakış yüklenemedi',
    notificationReviewStatusUpdated: '{count} sayfa başarıyla güncellendi',
    notificationSelectAllFailed: 'Tüm sayfalar seçilemedi',
    notificationUpdateReviewStatusFailed: 'İnceleme durumu güncellenemedi',
    publishBookIdentifierNotUnique: 'Kitap Tanımlayıcısı benzersiz olmalıdır.',
    publishBookIdentifierTakenHelp: 'Bu tanımlayıcıya sahip bir kitap zaten var.',
    publishFailed: 'Seçilen sayfalar yayınlanamadı',
    publishModalTitle: 'Seçilen Sayfaları Yayınla',
    publishNewBookHelpText: 'Başarıyla yayınlanan sayfalar, AI PDF İçe Aktarımına Genel Bakış sayfasında göründüğü sırayla yeni Kitaba eklenecek. Yalnızca seçilen en az bir sayfa başarıyla yayınlandığı takdirde yeni bir Kitap oluşturulacak.',
    publishNewBookIdentifierLabel: 'Kitap Tanımlayıcısı',
    publishOptionNewBook: 'Yeni bir Kitap oluştur ve sayfaları bu Kitaba ekle',
    publishOptionPagesOnly: 'Sadece sayfaları yayınla',
    reviewManagement: 'İnceleme Yönetimi',
    reviewManagementTooltip: 'Ayıklanmış içerikleri incelerken daha düzenli çalışmak için inceleme durumlarını kullanın. Onaylandı, Beklemede ve Bırakıldı durumları, yayınlanma biçimini etkilemez. Bunlar sadece inceleme durumunun takip edilmesi içindir.',
    reviewProgress: 'İnceleme İlerlemesi',
    title: 'Genel Bakış'
  },
  pdfImportPageDetails: {
    actionPublish: 'Sayfayı Yayınla',
    firstPage: 'İlk Sayfa',
    lastPage: 'Son Sayfa',
    matchingPageNewPage: 'Yeni Parça Sayfası',
    matchingPageNewPageSharedSvg: 'Yeni Parça Sayfası ancak SVG dosyası başka sayfalarla ortak',
    matchingPageOpenExisting: 'Mevcut sayfayı aç',
    matchingPageOverwrite: 'Mevcut Parça Sayfasının üzerine yazılacak',
    navLabel: 'AI PDF İçe Aktarımına Genel Bakış',
    navigationFailedText: '{pageNumber}. sayfaya gidilemedi',
    nextPage: 'Sonraki Sayfa',
    notificationLoadFailed: 'Sayfa yüklenemedi',
    notificationPublishFailed: 'Yayınlama işi gönderilemedi',
    notificationSaveFailed: 'Sayfa kaydedilemedi',
    notificationSaveSuccess: 'Sayfa başarıyla kaydedildi',
    pageOriginComposed: 'Birden fazla PDF sayfasından oluşuyor',
    pageOriginExtracted: 'Tek bir PDF sayfasından ayıklandı',
    pageOriginLabel: 'Sayfa Kaynağı',
    previousPage: 'Önceki Sayfa',
    publishPageModalHelpText: 'Parça Sayfası, kitap bağlamının dışında yayınlanacak. Yayınlandığında, sayfa kimliği kuralları doğrultusunda yeni bir Parça Sayfası oluşturulacak ya da mevcut bir sayfanın üzerine yazılacak.',
    thumbnailCardTitle: 'PDF Sayfası Küçük Resmi',
    viewBom: 'Malzeme Listesi'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Oluşturuldu',
    columnPdfPage: 'PDF Sayfaları',
    columnPublishingStatus: 'Yayınlama Durumu',
    detailLoadFailed: 'Yayınlama işi ayrıntıları yüklenemedi',
    emptyBookOperations: 'Bu işte hiçbir kitap işlemi gerçekleştirilmedi',
    emptyJobsHint: 'Sayfalar yayınlandıktan sonra yayınlama etkinlikleri burada görünecek.',
    emptyJobsTitle: 'Bu AI PDF İçe Aktarımı için henüz hiçbir yayınlama işi yürütülmedi.',
    emptyPagesTitle: 'Seçilen filtreyle eşleşen sayfa yok.',
    filterAllPages: 'Tüm Sayfaları Göster',
    filterFailedOnly: 'Yalnızca Başarısız Sayfaları Göster',
    filterNameQuery: 'Ad veya Sayfa Dosyası',
    filterPublishedOnly: 'Yalnızca Yayınlanan Sayfaları Göster',
    helpText: 'Bu sayfada, yayınlama sırasında oluşturulan, üzerine yazılan veya başarısız olan sayfalar dahil olmak üzere bu AI PDF İçe Aktarımında yayınlanan Parça Sayfalarının geçmişi gösterilir.',
    jobLabel: 'İş no. {number}',
    loadFailed: 'Yayınlama geçmişi yüklenemedi',
    resultPublishedCreated: 'Yayınlandı – Oluşturuldu',
    resultPublishedUpdated: 'Yayınlandı – Üzerine Yazıldı',
    resultSummaryBookCreated: 'Yeni bir kitap oluşturuldu.',
    resultSummaryNone: 'Hiçbir sayfa yayınlanmadı.',
    resultSummaryPagesFailed: '{n} sayfa başarısız oldu. | {n} sayfa başarısız oldu.',
    resultSummaryPagesPublished: '{n} sayfa yayınlandı. | {n} sayfa yayınlandı.',
    statusFailed: 'Başarısız',
    statusInProgress: 'Devam Ediyor',
    title: 'Yayınlama Geçmişi'
  },
  permission: 'İzin | İzinler',
  phoneNumber: 'Telefon Numarası',
  phoneNumberExt: 'Dahili',
  phonePrimary: 'Birincil Telefon Numarası',
  phoneSecondary: 'İkincil Telefon Numarası',
  pinFilter: 'Arama sonuçları sayfasına filtreyi sabitle',
  pinned: 'Sabitlenmiş',
  plusMoreOrgs: '+ {totalOrgCount} ek Kuruluş',
  polishDescription: 'Lehçe Açıklama',
  polishName: 'Lehçe Ad',
  populatePdfNameSelection: 'PDF Dosya Adı Seçimini doldur',
  populatePdfNameWith: 'PDF dosya adını şununla doldur:',
  port: 'Port',
  portrait: 'Portre',
  portugueseDescription: 'Portekizce Açıklama',
  portugueseName: 'Portekizce Ad',
  postComment: 'Yorum Gönder',
  postalCode: 'Posta Kodu',
  poweredBy: 'Destekleyen',
  preferences: 'Tercihler',
  preferencesDisable: 'Kullanıcı Tercihlerini Devre Dışı Bırak',
  prefix: 'Önek | Önekler',
  preview: 'Ön İzleme',
  previewOfName: '{name} önizlemesi',
  pricing: 'Fiyatlandırma',
  pricingDiscountEnabled: 'İndirimli Fiyatı Görüntüle',
  pricingDisplayInCart: 'Alışveriş Sepetinde Fiyatları Göster',
  pricingDisplayInPartsList: 'Parça Listesinde Fiyatları Göster',
  pricingGlobal: 'Global Fiyatlandırma',
  pricingGlobalDescription: 'Kuruluştan geçersiz kılma olmadığında normal fiyat',
  pricingHideInitially: 'Fiyatı başlangıçta gizle',
  pricingHidePricingButton: 'Fiyatlandırma Butonunu Gizleyi Etkinleştir',
  pricingHidePricingButtonDisable: 'Fiyatlandırma Butonunu Gizleyi Devre Dışı Bırak',
  pricingHidePricingButtonDisableHelp: 'Fiyatlandırmayı Gizle düğmesi, kullanıcıların fiyat düzeylerini gösterme/gizleme imkanını devre dışı bırakır. "Fiyatı başlangıçta gizle" olarak yapılandırılmış tüm fiyat düzeyleri gizli olarak kalır ve kullanıcılar bunları görünür hale getiremez.',
  pricingOrganization: 'Kuruluş Fiyatlandırması',
  pricingOrganizationDeleteConfirm: 'Bu Kuruluş fiyatlandırmasını silmek istediğinizden emin misiniz?',
  pricingOrganizationDescription: 'Kuruluş fiyatlandırması, bir Kuruluş ve onun alt Kuruluşları içindeki tüm kullanıcılar için global fiyatlandırmayı geçersiz kılar.',
  pricingOrganizationDuplicate: 'Bu kuruluş zaten geçersiz kılınıyor',
  pricingOrganizationEmptyState: 'Herhangi bir kuruluş geçersiz kılması tanımlanmadı. Başlamak için {add} ögesine tıklayın.',
  pricingRetailEnabled: 'Perakende Fiyatını Görüntüle',
  pricingWholesaleEnabled: 'Toptan Fiyatı Görüntüle',
  primary: 'Birincil',
  print: 'Yazdır',
  printJob: 'İşi Yazdır',
  printLogo: 'Yazdırma Logosu',
  printSetting: 'Yazdırma Ayarı',
  printSettingCopyMessage: 'Yeni Yazdırma Ayarı için benzersiz bir ad girin.',
  printSettingCreated: 'Yazdırma Ayarı oluşturuldu',
  printSettingDeleteFail: 'Yazdırma Ayarı Silinemedi',
  printSettingEmptyMessage: 'Tanımlanmış Yazdırma Ayarı Yok. Başlamak için bir Yazdırma Ayarı ekleyin.',
  printSettingSaveFail: 'Yazdırma Ayarı Kaydedilemedi',
  printSettingSelectionRequired: 'Yazdırma Ayarı seçimi gerekli.',
  printSettingSetDefaultSuccess: 'Varsayılan Yazdırma Ayarı seti',
  printSettingUpdateFail: 'Yazdırma Ayarı Güncellenemedi',
  printSettings: 'Yazdırma Ayarları',
  printSettingsLogo: 'Yazdırma Ayarları Logosu',
  printerLane: 'Yazıcı Yolu',
  printing: 'Yazdırılıyor',
  printingDisabled: 'Tüm Yazdırmaları Devre Dışı Bırak',
  privacyPolicy: 'Gizlilik Politikası',
  proceed: 'Devam Et',
  process: 'İşlem',
  processContent: 'Süreç İçeriği',
  processToDraft: 'Taslağa İşle',
  processedPlzToDraft: 'Taslağa İşlenmiş PLZ(ler)',
  processing: 'İşleniyor',
  productCategory: 'Ürün Kategorisi | Ürün Kategorileri',
  productCategoryName: 'Ürün Kategorisi Adı',
  productId: 'Ürün Kimliği',
  productIdErrorMessage: 'Bir Ürün Kimliği gereklidir',
  productIdMessage: 'Kullanıcıların ürünü bulmak için kullanacağı tanımlayıcı değer, örn. "FTX1000"',
  productPage: 'Ürün Sayfası | Ürün Sayfaları',
  productPageAccessControlDescription: 'Erişim Kontrolleri, Kuruluşlar ve Kullanıcı Grubu atamalarına bağlı olarak bu sayfayı kimlerin görebileceğini tanımlar.',
  productPageCreated: 'Ürün Sayfası Oluşturuldu',
  productPageDescription: 'Ürün Sayfası Açıklaması',
  productPageIdentifierMessage: 'Bu sayfa için benzersiz bir dahili tanımlayıcı',
  productPageName: 'Ürün Sayfası Adı',
  productPageProductId: 'Ürün Sayfası Ürün Kimliği',
  productPageUpdated: 'Ürün Sayfası Güncellendi',
  productPagesBulkImport: {
    description: 'Ürün sayfalarını toplu içe aktarma işlemine göndermek için veri dosyanızı yükleyin. Desteklenen dosya formatı: XLSX.',
    downloadUnprocessedRows: 'İşlenmemiş Satırlar Elektronik Tablosunu İndir',
    overwriteAccessControls: 'Erişim kontrollerinin üzerine yaz (Kuruluşlar ve Kullanıcı Grupları)',
    overwriteAssociatedMedia: 'İlişkili medyanın üzerine yaz',
    requirements: {
      enUSCategory: {
        description: 'Belirli bir dilin mevcut Ürün Kategorisi Adı. <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Dil Desteği Kılavuzumuza</a> başvurun.'
      },
      enUSDescription: {
        description: 'Bir ürün sayfası için dile özgü çeviri açıklaması. <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Dil Desteği Kılavuzumuza</a> başvurun.'
      },
      enUSName: {
        description: 'Bir ürün sayfası için dile özgü çeviri adı. Yeni ürün sayfaları için en az bir çeviri zorunludur. <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Dil Desteği Kılavuzumuza</a> başvurun.'
      },
      identifier: {
        description: 'Bir ürün sayfası için, yalnızca Yönetici Merkezi’nde görüntülenebilen ve aranabilen benzersiz tanımlayıcı.'
      },
      media: {
        description: 'Belirli bir ürün sayfasıyla ilgili medya tanımlayıcılarının listesi. Birden fazla değer kullanacaksanız her birini &#124; ile ayırın.'
      },
      organizations: {
        description: 'Belirli bir ürün sayfasına erişebilen kuruluşların listesi. Birden fazla değer kullanacaksanız her birini &#124; ile ayırın.'
      },
      productId: {
        description: 'Son kullanıcılar için, Kitaplık’ta görüntülenebilen ve aranabilen bir ürün sayfası tanımlayıcısı. Ürün Kimlikleri benzersiz değerler olmak zorunda değildir.'
      },
      tagInternalName: {
        description: 'Etiketleri bir ürün sayfasıyla ilişkilendirir. Birden fazla değer kullanacaksanız her birini &#124; ile ayırın. Örnek: Kırmızı &#124; Yeşil &#124; Mavi.'
      },
      thumbnail: {
        description: 'Küçük resim dosya adı. İzin verilen uzantılar: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Belirli bir ürün sayfasına erişebilen kullanıcı gruplarının listesi. Birden fazla değer kullanacaksanız her birini &#124; ile ayırın.'
      }
    },
    success: 'Ürün sayfalarını toplu içe aktarma işi oluşturuldu',
    title: 'Ürün Sayfalarını Toplu İçe Aktarma'
  },
  production: 'Üretim',
  professional: 'Profesyonel',
  profile: 'Profil',
  prohibitExportDownloadOfContent: 'İçeriği Dışa Aktarmayı/İndirmeyi Yasakla',
  prohibitExportDownloadOfContentHelpText: '\'Etkinleştir\' olarak ayarlamak, (bu ayrıcalıklara sahip) kullanıcıların bu içeriği dışa aktarmasını veya indirmesini engelleyecektir.',
  property: 'Özellik | Özellikler',
  province: 'İl',
  'public': 'Halka Açık',
  publish: 'Yayınla',
  publishDocuments: 'Belgeleri Yayınla',
  publishDraft: 'Taslağı Yayınla',
  publishThumbnailJob: 'Küçük Resmi Yayınla',
  publisher: 'Yayıncı | Yayıncılar',
  publisherJob: 'Yayınlayıcı İşi',
  publisherLane: 'Yayıncı Yolu',
  publisherManualLane: 'Yayıncı Manuel Yolu',
  publisherMessage: 'İçerik oluşturma, yönetme ve yazdırma ayarları',
  publishingErrors: 'Yayımlama Hataları',
  publishingErrorsWithName: 'Yayınlama Hataları {name}',
  publishingInProgress: 'Yayımlama devam ediyor, gönderilemez',
  purchaseOrder: 'Satın Alma Emri',
  purchaseOrderTemplateDisabled: 'Sipariş Şablonlarını Devre Dışı Bırak',
  purchaseOrderTemplateEnabled: 'Sipariş Şablonlarını Etkinleştir',
  qty: 'Mkt',
  quantity: 'Miktar',
  query: 'Sorgu',
  quickAdd: 'Hızlı Ekle',
  quickAddHelpText: 'Alışveriş sepetine ekleyeceğiniz parçaları bulmak için yazmaya başlayın.',
  quickAddInCartEnabled: 'Sepete Hızlı Eklemeyi Etkinleştir',
  quickLinks: 'Hızlı Bağlantılar',
  quote: 'Teklif | Teklifler',
  quoteFormType: 'Teklif Formu',
  quoteTemplateDisabled: 'Teklif Şablonlarını Devre Dışı Bırak',
  quoteTemplateEnabled: 'Teklif Şablonlarını Etkinleştir',
  range: 'Aralık',
  rearrange: 'Yeniden düzenle',
  rebuildIndexJob: 'Dizini Yeniden Oluştur',
  recentSearches: 'Son Aramalar',
  recentlyAdded: 'Son Eklenenler',
  recentlyEdited: 'Son Düzenlenenler',
  recentlyViewed: 'Son Görüntülenenler',
  recipientOrRecipients: 'Alıcı(lar)',
  rectangle: 'Dikdörtgen',
  redirect: 'Yeniden Yönlendir',
  refresh: 'Yenile',
  related: 'İlgili',
  relatedDescription: 'Kütüphanede bulunan medyayı bu {type} ile ilişkilendirin. Kullanıcıların \'İlgili\' sekmesinde görebilmesi için ilgili medyaya erişim kontrolleri uygulanmış olmalıdır.',
  relatedInfo: 'İlgili Bilgi',
  relatedView: 'İlgili Medyayı Görüntüle',
  relationship: 'İlişki | İlişkiler',
  releaseNotes: 'Sürüm Notları',
  remainingWidth: 'Kalan Genişlik',
  rememberMe: 'Beni hatırla',
  remove: 'Kaldır',
  removeAll: 'Tümünü Kaldır',
  removeItemConfirmation: '{item} ögesini silmek istediğinizden emin misiniz?',
  removeItemCount: ' {count} {type} ögesini silmek istediğinizden emin misiniz?',
  replace: 'Değiştir',
  replaceExisting: 'Var Olanı Değiştir',
  report: 'Rapor | Raporlar',
  reportAnIssue: 'Sorun Bildir',
  reportAnIssueMessage: 'E-posta başarılı şekilde gönderildi.',
  reportCatalogName: 'Rapor Kataloğu Adı',
  reportCatalogNotSet: 'Rapor için rapor kataloğu tanımlanmadı.',
  reportDefinition: 'Rapor Tanımı | Rapor Tanımları',
  reportDefinitionDeleteError: 'Rapor tanımı silinemedi',
  reportExportTimeWarning: 'Kayıt sayısına ve seçili biçime bağlı olarak dışarı aktarmanın tamamlanması birkaç dakika sürebilir.',
  reportSettings: 'Rapor Ayarları',
  reporting: 'Raporlama',
  reportingMessage: 'Çeşitli raporlara ve metriklere erişim',
  reportsEmptyState: 'Rapor yok',
  reportsLibrary: 'Rapor Kitaplığı',
  requestForQuote: 'Fiyat Teklifi İste',
  requestFormType: 'Teklif Formu',
  requireAuthentication: 'Kimlik Doğrulama İste',
  required: 'Gerekli',
  requiredField: 'Gerekli Alan',
  requiredItem: '{item} gereklidir.',
  requiredMessage: 'Bir {item} gerekli.',
  requiredMessageAndUnique: 'Bir {type} gereklidir ve benzersiz olmalıdır.',
  requiredReading: 'Gerekli Okuma',
  requiredReadingMessage: 'Lütfen şunları gözden geçirin:',
  requiredType: 'Bir tür gerekli.',
  requiredUrlMessage: 'İyi biçimlendirilmiş bir URL gerekli.',
  reset: 'Sıfırla',
  resetPassword: 'Parolayı Sıfırla',
  resetPasswordError: 'Parolanız sıfırlanırken bir sorun oluştu, lütfen tekrar deneyin.',
  resetPasswordTokenError: 'Parola sıfırlama belirteci geçerli değil.',
  resetZoom: 'Yakınlaştırmayı Sıfırla',
  resize: 'Yeniden Boyutlandır',
  resizeThumbnails: 'Küçük resimleri otomatik olarak yeniden boyutlandır',
  resource: 'Kaynak | Kaynaklar',
  result: 'Sonuç | Sonuçlar',
  resultFor: '{item} için Sonuç | {item} için Sonuçlar',
  retail: 'Perakende',
  retailPrice: 'Perakende Fiyatı',
  retailTotal: 'Perakende Toplamı',
  'return': 'Dön',
  returnToItem: '{item} ögesine dön',
  returnToMedia: 'Medyaya Dön',
  returnToPartList: 'Parça Listesine Dön',
  returnToTemplate: 'Şablona Dön',
  returnToViewer: 'Görüntüleyiciye Dön',
  revert: 'Geri Al',
  revertChanges: 'Değişiklikleri Geri Al',
  revertChangesMsg: 'Değişikliklerinizi geri almak istediğinizden emin misiniz?',
  right: 'Sağ',
  romanianDescription: 'Romence Açıklama',
  romanianName: 'Romence Ad',
  rootLevelBrowseFlow: 'Kök Seviyesi',
  row: 'Sıra',
  russianDescription: 'Rusça Açıklama',
  russianName: 'Rusça Ad',
  s3DataExportsEnabled: 'S3 Veri Dışa Aktarımlarını Etkinleştirme',
  sampleData: 'Örnek Veriler',
  samplePreview: 'Örnek Önizlemesi',
  sandbox: 'Sandbox',
  sat: 'Cmt',
  save: 'Kaydet',
  saveAndClose: 'Kaydet ve Kapat',
  saveAndEditTarget: 'Kaydet ve Hedefi Düzenle',
  saveChanges: 'Değişiklikleriniz {item} ögesine kaydedilsin mi? {name}',
  saveChangesToItem: 'Değişiklikleriniz bu {item} ögesine kaydedilsin mi?',
  saveNewAPIKey: 'Yeni Entegrasyon Anahtarı Kaydedilmedi, Kurulumu tamamlamak üzere dönün',
  saveNewWidgetKey: 'Yeni Widget Anahtarı kaydedilmedi. Kurulumu tamamlamak için geri dön.',
  saveOrderAttachmentsError: 'Sipariş Dosya Ekleri kaydedilemedi.',
  saved: 'Kaydedildi',
  search: 'Ara',
  searchAllContent: 'Tüm İçeriği Ara',
  searchCategories: 'Kategoriler',
  searchConfiguration: 'Arama Yapılandırması',
  searchContent: '{content} Ara',
  searchCriteria: 'Arama Kriteri',
  searchDocumoto: 'Documoto’da Ara',
  searchFeatures: 'Arama Özellikleri',
  searchFieldConfigDescription: 'Aşağıdaki sistem alanı arama ayarları yalnızca Kütüphane genel araması, arama sonuçları sayfası ve Sepet alanındaki Hızlı Ekle bölümlerinde uygulanır. Diğer arama özellikleri (ör. Yönetici Merkezi araması ve Kullanıldığı Kütüphane) etkilenmez.',
  searchInContent: 'Şuradaara {contentName}...',
  searchPlaceholder: 'Tüm içeriği ara…',
  searchPrompt: 'Tüm içeriği ara…',
  searchProperty: 'Özellik Ara | Özellikleri Ara',
  searchResults: 'Arama Sonuçları',
  searchResultsConfiguration: 'Arama Sonuçları Yapılandırması',
  searchSettings: 'Arama Ayarları',
  searchSettingsDescription: 'Bu ayarlar, çeşitli Kütüphane arama tarzını, özelliklerini ve sonuçlarını kontrol eder.',
  searchTerm: 'Arama Terimi',
  searchTips: 'Arama İpuçları:',
  searchType: 'Tür',
  searchable: 'Aranabilir',
  searchableFieldsSuccessfullyUpdated: 'Aranabilir Alanlar Başarıyla Güncellendi.',
  searchableTag: 'Aranabilir Etiket',
  searchingInLanguage: 'Sadece {lang} dilinde aranıyor',
  searchingInTwoLanguages: 'Sadece {lang1} ve {lang2} dillerinde aranıyor',
  section: 'Bölüm',
  select: 'Seç',
  selectAField: 'Bir {field} seçin',
  selectAll: 'Tümünü Seç',
  selectAndClose: 'Seç ve Kapat',
  selectChapters: 'Örnek Bölümler',
  selectChildren: 'Alt Kuruluşları Seçin',
  selectFields: 'Bir {field} seçin',
  selectItem: '{item} öğesini seç',
  selectMedia: 'Medya Seç',
  selectPage: 'Sayfa Seçin',
  selectPages: 'Sayfaları Seç',
  selectTargetPage: 'Hedef Sayfa Seçin',
  selected: 'Seçildi',
  selectedTargetPage: 'Seçilmiş Hedef Sayfa',
  send: 'Gönder',
  sendReverificationEmail: 'Yeniden Doğrulama E-Postası Gönder',
  sendVerificationEmail: 'Doğrulama E-Postası Gönder',
  september: 'Eylül',
  sequence: 'Sıralama',
  serbianDescription: 'Sırpça Açıklama',
  serbianName: 'Sırpça Ad',
  serviceUri: 'Hizmet URI\'si',
  sessionLog: 'Oturum Günlüğü',
  set: 'Ayarla',
  setAsDefault: 'Varsayılan Olarak Ayarla',
  setPassword: 'Parola Belirle',
  settings: 'Ayarlar',
  settingsMessage: 'Kullanıcı tercihlerinizi ve parolanızı güncelleyin',
  shape: 'Şekil',
  shapeTool: 'Şekil Aracı',
  shared: 'Paylaşımlı',
  sharedCart: 'Paylaşılan Sepet | Paylaşılan Sepetler',
  sharedCartDeleteContent: 'Bu, bu Paylaşılan Sepeti, paylaşıldığı tüm Kuruluşlar için kaldıracaktır.',
  sharedCartOrganizationContent: 'Bu Paylaşılan Sepeti Kullanabilecek Kuruluşları Seçin.',
  sharedShoppingCartsEnabled: 'Paylaşılan Alışveriş Sepetlerini Etkinleştir',
  shoppingCartExportJob: 'Alışveriş Sepeti Dışarı Aktarma',
  shoppingCartLoadingLongTime: 'Alışveriş sepeti yükleniyor. Alışveriş sepeti simgesi, işlem tamamlandıktan sonra tekrar kullanılabilir olacaktır. Sorun devam ederse destek için lütfen Documoto Yöneticileri ile iletişime geçin.',
  showChapterTOCForHiddenPages: 'Gizli Sayfalar İçin Bölüme Ait İçindekileri Göster',
  showExportFromSearch: 'Arama Sonuçlarından Dışa Aktarmaya İzin Ver',
  showExportFromSearchHelp: 'Bir aramadan kaynaklanan kitap listesinin dışa aktarılmasına izin ver',
  showHelp: 'Yardımı Göster',
  showIdentifierInLibrary: 'Kitaplıkta Medya ve Ürün Sayfası Tanımlayıcılarını Göster',
  showIdentifierInSearch: 'Aramada Medya Tanımlayıcıyı Göster',
  showItem: '{item} Göster',
  showLess: 'Daha Az Göster',
  showMediaDescriptionFilter: 'Medya Açıklama Filtresini Göster',
  showMediaIdentifierFilter: 'Medya Tanımlayıcı Filtresini Göster',
  showMediaNameFilter: 'Medya Adı Filtresini Göster',
  showMore: 'Daha Fazla Göster',
  showOnlyExactMatches: 'Sadece Tam Eşleşmeleri Göster',
  showOrganizationFilter: 'Kuruluş Filtresini Göster',
  showPartNameFilter: 'Parça Adı Filtresini Göster',
  showPartNumberFilter: 'Parça Numarası Filtresini Göster',
  showRecentlyAdded: 'Son Eklenenleri Göster',
  showRecentlyViewed: 'Son Görüntülenenleri Göster',
  showSearchButton: 'Ana Sayfa Arama Butonunu Göster',
  showSearchButtonHelp: 'Kitaplık başlığında \'Aramaya Git\' `butonunu göster',
  signature: 'İmza',
  size: 'Boyut',
  snapshot: 'Anlık Görüntü | Anlık Görüntüler',
  solrSlaveSvrOverride: 'SOLR Bağımlı Sunucu Temel URL Geçersiz Kılma',
  sortAsc: '{value} A-Z',
  sortDesc: '{value} Z-A',
  sortRelevant: 'En İlgili',
  sortType: 'Sıralama Türü',
  sourceBrowseFlow: 'Kaynak Göz Atma Akışı',
  sourceFile: 'Kaynak Dosya',
  sourceFilename: 'Kaynak Dosya Adı',
  spanishDescription: 'İspanyolca Açıklama',
  spanishName: 'İspanyolca Ad',
  square: 'Kare',
  ssoConfiguration: 'SSO Yapılandırması',
  ssoIdpMetadataUrl: 'SSO IDP Meta Veri URL‘si',
  ssoLoginMaxAuthenticationAgeSeconds: 'SSO Giriş Maksimum Kimlik Doğrulama Yaşı Saniye',
  ssoSamlDnAttributeName: 'SSO SAML DN Öznitelik Adı',
  ssoSamlEmailAttributeName: 'SSO SAML E-posta Öznitelik Adı',
  ssoSamlMemberofAttributeName: 'SSO SAML Üyesi Öznitelik Adı',
  ssoSniForSsoMetadataRetrieval: 'SSO Meta Veri Alımı İçin SNI Kullan',
  standard: 'Standart',
  standardUserGroup: 'Standart Kullanıcı Grubu',
  startDate: 'Başlangıç Tarihi',
  startDateRequired: 'Başlama tarihi gerekli.',
  state: 'Eyalet',
  'static': 'Statik',
  status: 'Durum',
  statusCode: 'Durum Kodu | Durum Kodları',
  stitchPages: 'Dikiş Sayfaları',
  storeFilterValues: 'Filtre Değerlerini Depola',
  storeFilterValuesDescription: 'Bu ayarı etkinleştirmek, bu etiket için kullanıcılar tarafından arama sayfası filtrelerinde ayarlanan değerleri depolar.',
  storeFrontAdmin: 'Vitrin Yöneticisi',
  storefront: 'Vitrin',
  storefrontIntegration: 'Vitrin Entegrasyonu | Vitrin Entegrasyonları',
  storefrontIntegrationSubtitle: 'Bu ayarlar, çeşitli Vitrin Entegrasyonu ögelerini ve seçeneklerini kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Destek Merkezi ile iletişime geçin.',
  storefrontSettings: 'Vitrin Ayarları',
  storefrontSettingsDescription: 'Bu ayarlar, çeşitli Vitrin ögelerini ve seçeneklerini kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Hizmetleri ile iletişime geçin.',
  storefrontSettingsOrgDescription: 'Bu ayarlar, Kuruluş düzeyindeki çeşitli Vitrin ögelerini ve seçeneklerini kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Hizmetleri ile iletişime geçin.',
  stroke: 'Fırça Darbesi',
  style: 'Stil | Stiller',
  styles: {
    colorHotpoint: 'Etkin Nokta Varsayılan',
    inheritedFromOrg: 'Kuruluştan devralındı {org}',
    inheritedFromSystem: 'Sistem Varsayılanından devralındı',
    inheritedFromTenant: 'Kiracıdan devralındı',
    invalidHexcode: 'Geçersiz onaltılı kod',
    organization: 'Kuruluş Stili | Kuruluş Stilleri',
    organizationSaved: 'Kuruluş Stilleri Kaydedildi',
    sampleNavigation: 'Navigasyon Sekmeleri',
    samplePrimary: 'Navigasyon/Düğmeler',
    sampleSelectedHotpoint: 'Seçili Etkin Noktalar',
    tenant: 'Kiracı Stili | Kiracı Stilleri',
    tenantSaved: 'Kiracı Stilleri Kaydedildi'
  },
  subChapter: 'Alt Bölüm | Alt Bölümler',
  subject: 'Konu',
  subjectMessage: 'Konu gerekli',
  submit: 'Gönder',
  submitPurchaseOrder: 'Satın Alma Emri',
  submitRequestForQuote: 'Fiyat Teklifi İste',
  submitted: 'Gönderildi',
  submittedBy: 'Gönderen kişi',
  submittedFilesMessage: '{fileCount} dosya gönderildi.',
  submitter: 'Gönderen',
  submitterEmail: 'Gönderen E-postası',
  submitterFirstName: 'Gönderen Adı',
  submitterLastName: 'Gönderen Soyadı',
  submitterOrgName: 'Gönderen Kuruluş Adı',
  submitterUserName: 'Gönderen Kullanıcı Adı',
  success: 'Başarılı',
  successNotificationDuration: 'Sepete Ekleyin - Başarılı Toast Bildirim Süresi',
  suffix: 'Son Ek | Son Ekler',
  suggestedKeywords: 'Önerilen Anahtar Kelimeler',
  suggestedResults: 'Önerilen Sonuçlar',
  suggestion: 'Öneri | Öneriler',
  sun: 'Paz',
  superAdminSettings: 'Süper Yönetici Ayarları',
  superadmin: 'Süper Yönetici',
  supersede: 'Yerini Al',
  supersedeComplete: 'Yerini alma işlemini tamamlamak istiyor musunuz?',
  supersedeDiscardChanges: 'Yerini alma işlemini göz ardı et?',
  supersedeMainText: 'Eski parçanın bulunduğu her Parça Sayfasında, mevcut bir parçayı bir veya daha fazla başka parçayla değiştirir. Eski parça numarası silinir ancak etiketler aracılığıyla aranabilir, böylece içerik eski numara veya yeni numara(lar) kullanılarak bulunabilir.',
  supersedeMessage: 'Parça güncellemeleri anında etkili olur. Arama birkaç dakika içinde güncellemeleri yansıtacaktır.',
  supersedeNotProcessed: 'Yerini alma işleminiz işleme alınmayacak.',
  supersedeReplacePart: 'Parçanın yerini alacak bir veya daha fazla parça bulun',
  supersedeSuccessful: 'Yer Değiştirme Başarılı',
  supersedeWith: 'Parçayı ... ile Yer Değiştir',
  superseded: 'Yerine Geçmiş',
  supersededParts: 'Yerine Geçmiş Parçalar',
  supplier: 'Sağlayıcı | Sağlayıcılar',
  supplierDescription: 'Bu parçayı tedarik eden firma',
  supplierKey: 'Sağlayıcı Anahtarı',
  supportedDraftArchives: 'Desteklenmeyen dosya; desteklenen taslak dosya türleri: MDZ, PLZ',
  supportedImageFormats: 'Desteklenen resim formatları: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Tam eşleşmeleri görmek için birden fazla arama teriminin başına ve sonuna tırnak işareti koyun.',
  svgFinder: 'Ölçeklenebilir Vektör Grafikleri (SVG) Sorgulayıcı',
  swedishDescription: 'İsveççe Açıklama',
  swedishName: 'İsveççe Ad',
  system: 'Sistem',
  systemAdmin: 'Sistem Yöneticisi',
  systemFieldSearchAndFiltering: 'Sistem Alanı Araması ve Filtreleme',
  systemFields: 'Sistem Alanları',
  systemName: 'Sistem Adı',
  systemStatus: 'Sistem Durumu',
  systemVersion: 'Sistem Sürümü',
  tabDelimited: 'Sekme sınırlandırıldı',
  tableOfContents: 'İçindekiler',
  tabloid: 'Tabloid',
  tag: 'Etiket | Etiketler',
  tagDeleteAffectedCount: 'Bu, etiketi siler ve etiket bilgilerini {count} ögeden kaldırır.',
  tagDeleteAffectedNone: 'Şu anda bu etiketi kullanan hiçbir öge yok.',
  tagEditor: {
    filterPrompt: 'İlk 100 değer görüntüleniyor. Daha fazlasını görüntülemek için filtreyi kullanın.',
    rangeBoundLengthInvalid: 'Cilt, {limit} rakamdan fazla olamaz.',
    tagEditorModal: 'Etiket Düzenleyici Modeli',
    textfieldHelpText: 'Noktalı virgülle ayrılmış bir veya birden fazla değer girin. Örnek: SN001; SN002'
  },
  tagManagerDeleteWarning: '{deleteCategoryName} ögesine sahip bir mevcut medya, silindikten sonra bu kategoriyi kaybedecektir.',
  tagName: 'Etiket Adı',
  tagSearchAndFiltering: 'Etiket Araması ve Filtreleme',
  tagSearchAndFilteringHelpText: 'İpucu: Bazı arama ve filtre ayarları, burada bulunan Etiket Yönetimi etiket düzenleyicileri kısmından da yapılandırılabilir: ',
  tagSubmitAffected: 'Herhangi bir {type} içeriği, değişikliklere ek olarak {tag} etiketini otomatik olarak bırakacaktır.',
  tagValue: 'Etiket Değeri | Etiket Değerleri',
  tagValueMissing: 'Bir etiket değeri girmeniz gerekiyor',
  tagValueMultiple: 'Birden çok giriş için ayrılmış noktalı virgül',
  tagValueTooLong: 'Etiket değeri 25 karakter sınırını aşıyor | Etiket değerleri 25 karakter sınırını aşıyor',
  tagsDeleteError: 'Bir veya daha fazla etiket silinemedi',
  tagsDeleteSuccess: 'Etiketler başarıyla silindi',
  tagsDisplayMore: 'İlk 100 değer görüntüleniyor. Daha fazlasını görüntülemek için filtreyi kullanın.',
  tagsManager: 'Etiket Yöneticisi',
  tagsSaveError: 'Bir veya daha fazla etiket kaydedilemedi',
  tagsSaveSuccess: 'Etiketler başarıyla kaydedildi',
  tagsUpdateError: 'bir veya daha fazla etiket güncellemesi başarısız oldu',
  tagsUpdateSuccess: 'Etiketler başarıyla güncellendi',
  targetBrowseFlow: 'Hedef Göz Atma Akışı',
  taxon: 'Takson',
  taxonomy: 'Taksonomi',
  template: 'Şablon | Şablonlar',
  templateEmailRecipients: 'Şablon E-posta Alıcıları',
  templateLayout: {
    addItem: 'Öge Ekle',
    addRow: 'Satır Ekle',
    deleteColumn: 'Sütun Sil',
    deleteRow: 'Satır Sil',
    fullWidth: 'Tam Genişlik',
    oneColumn: 'Tek Sütun',
    threeColumns: 'Üç Sütun',
    twoColumns: 'İki Sütun'
  },
  tenant: 'Kiracı | Kiracılar',
  tenantAdmin: 'Kiracı Yöneticisi',
  tenantAdminMessage: 'Genel kiracı ayarlarını kontrol eder',
  tenantCleanerJob: 'Kiracı Bakımı',
  tenantConfiguration: 'Kiracı Yapılandırması',
  tenantEmailRecipients: 'Kiracı E-posta Alıcıları',
  tenantEmailRecipientsOverrideMessage: 'Kuruluş E-posta Alıcıları belirtilirse bunlar geçersiz kılınır',
  tenantIndexQueueJob: 'Kiracı Dizin Kuyruğu',
  tenantKey: 'Kiracı Anahtarı',
  tenantKeyError: 'Kiracı Anahtarı benzersiz değil',
  tenantKeyMessage: 'Kiracı Anahtarı benzersiz olmalıdır',
  tenantLabelDeleteMessage: 'Bu etiket silindiğinde, varsayılan Documoto adına geri dönecektir.',
  tenantLabelsPageText: 'Etiketler, Documoto\' nun Kitaplık ve Yönetim ekranlarında bulunan birçok nesnenin isimlerini özelleştirmek için kullanılır.',
  tenantPrintSettingsDescription: 'Kiracı genelinde varsayılan yazdırma ayarını seçin. Bu, Kuruluş veya Medyada geçersiz kılınmadıkça tüm kitap baskıları için kullanılacaktır.',
  tenantReindexModulus: 'Kiracı Yeniden Dizinleme Modülü',
  tenantSettings: {
    collapseTOCLabel: 'Eşleşen Sayfada İçindekiler`i Daralt',
    defaultLocaleLabel: 'Varsayılan Yerel Ayar',
    defaultLocaleMessage: 'Kiracı varsayılan yerel ayarı.',
    defaultSupplierLabel: 'Varsayılan Tedarikçi',
    defaultSupplierMessage: 'Kiracı varsayılan tedarikçisi.',
    deleteMissingTranslationsOnPublishLabel: 'Yayınlama Esnasında Eksik Çeviriler Silinsin mi?',
    deleteMissingTranslationsOnPublishMessage: 'Yayınlama Esnasında Bölüm Çevirilerini Silmeyi Etkinleştir',
    enableChapterIndexingLabel: 'Medya Bölümleri için indekslemeyi açar',
    enableChapterIndexingMessage: 'İndeks Bölümleri',
    enableIndexingLabel: 'Yayımlarken Dizin Oluştur',
    enableIndexingMessage: 'Yayımlama için dizin oluşturmayı etkinleştirir.',
    excludePartsFromAccessControlChecksLabel: 'Parçaları Erişim Kontrolü Kurallarından Çıkarma',
    excludePartsFromAccessControlChecksMessage: 'Bunu etkinleştirildiğinizde, Parçalar Medya Erişim Kontrollerinden bağımsız olarak tüm kullanıcılar tarafından görülebilir.',
    exportPgAsHashLabel: 'Sayfa Dosya Adını Hash Anahtarı Olarak Dışa Aktar',
    exportPgAsHashMessage: 'Dışa Aktarılan İçerikte Sayfa Dosyası Adı Olarak Sayfa Hash Anahtarlarını Kullan',
    helpUrlLabel: 'Varsayılan Yardım URL`si',
    helpUrlMessage: 'Alternatif bir yardım sisteminin URL`si.',
    hotPointLinkPageInBookOnlyLabel: 'Sayfa Etkin Nokta Bağlantıları Yalnızca Kitapta',
    hotPointLinkPageInBookOnlyMessage: 'Sayfalardan Etkin Nokta Bağlantıları Yalnızca Kitapta',
    lockPartTrOnPublishLabel: 'Yayınlama Esnasında Bölüm Çevirilerini Kilitle',
    lockPartTrOnPublishMessage: 'Yayınlama esnasında Bölüm Çevirilerinin değiştirilmesini önler',
    mediaTimestampLabel: 'Erişim Kontrolü Değişikliğinde Medya Zaman Damgasını Güncelle',
    mediaTimestampMessage: 'Erişim denetimi medya kategorilerindeki bir değişikliğin medyanın zaman damgasını güncellemesi gerekiyorsa etkinleştirin.',
    publisherDefaultUom: 'Yayımcı Ölçü Birimi Öndeğeri',
    publishingContactLabel: 'İletişim E-postası Yayınlanıyor',
    publishingContactMessage: 'Bir içerik sorunu bildirildiğinde e-postaları teslim alacak varsayılan e-posta adresi.',
    replaceHotpointLabel: 'Yayınlarken Daima Hotpoint Bağlantılarını Değiştirin',
    replaceHotpointMessage: 'Yalnızca Docustudio yayını için.',
    ssoLoginSystemLabel: 'Tek Adımlı Oturum Açma Sistemi',
    ssoLoginSystemMessage: 'Tek Adımlı Oturum Açma için Kimlik Tanımlayıcı sistemi.',
    userPasswordExpirationLabel: 'Kullanıcı Parolası Süre Dolumu Gün',
    userPasswordExpirationMessage: 'Parolaların sıfırlanması için geçmesi gereken Gün Sayısı; sürenin hiçbir zaman dolmaması için boş bırakın'
  },
  tenantSettingsSaved: 'Geçici Kullanıcı Ayarları Kaydedildi',
  tenantSettingsSubtitle: 'Bu ayarlar, geçici kullanıcı çapındaki nitelikleri ve davranışları kontrol eder. Değişiklik yaparken dikkatli olun. Daha fazla bilgi için Documoto Hizmetleri ile iletişim kurun.',
  tenantSettingsTitle: 'Geçici Kullanıcı Ayarları',
  tenantSuppliers: 'Kiracı Sağlayıcıları',
  tenantType: 'Kiracı Türü',
  tenantWebserviceUser: 'Kiracı Web Hizmeti Kullanıcısı',
  text: 'Metin',
  textArea: 'Metin Alanı',
  textColor: 'Metin Rengi',
  textField: 'Metin Alanı',
  textFile: 'Metin Dosyası (CSV, TXT)',
  textTool: 'Metin Aracı',
  threeD: {
    addFile: 'Bir 3D Parçası Dosyası Ekleyin',
    beforeSaveModal: {
      message: 'Bu dosyayı bulunduğu her yerde mi yoksa sadece bu kısımda mı değiştirmek istiyorsunuz? Dosyayı değiştirmeyi seçtiğinizde şunlar olacaktır:',
      messageBulletOne: '{count} parça(lar), bu yeni CAD dosyasıyla güncellenecektir',
      messageBulletOneForContent: '{count} {contentType} ögesi bu yeni CAD dosyasıyla güncellenecek.',
      messageBulletTwo: 'Bu dosyanın önceki sürümü, Documoto dosya sisteminden kaldırılacaktır',
      tip: 'İpucu: Ekleme işlemi esnasında herhangi bir dosyanın üzerine yazmayı önlemek için içe aktarmayı denemeden önce eklemek istediğiniz dosyanın adını değiştirebilirsiniz.',
      title: 'Documoto içerisinde aynı dosya adını taşıyan bir CAD dosyası zaten mevcut.'
    },
    deleteTitle: 'Bu 3D görünümü silmek istediğinizden emin misiniz?',
    drawMode: {
      hiddenLines: 'Gizli Çizgiler',
      label: 'Çizim Modu',
      shaded: 'Gölgeli',
      wireframe: 'Şema',
      wireframeShaded: 'Gölgeli Şema'
    },
    explode: 'Genişlet',
    failureCreatingBomAssociations: '3D model BOM bileşenleri oluşturulamadı.',
    fileSizeModal: {
      message: 'Documoto içerisinde izin verilen maksimum dosya boyutu 25 megabayttır. Karşıya yüklemeye çalıştığınız dosya en büyük boyutu aştı ve yüklenemiyor. Devam etmek için “Tamam” seçeneğine tıklayın.',
      title: 'En Fazla Dosya Boyutu Aşıldı'
    },
    fileSizeModalWarning: {
      message: 'Documoto\'da izin verilen maksimum bağımsız dosya boyutu {size} megabayttır. Yüklemeye çalıştığınız dosyalardan biri maksimum boyutu aşıyor ve yüklenemiyor. Devam etmek için "Tamam" ögesine tıklayın.',
      title: 'En Fazla Dosya Boyutu Aşıldı'
    },
    freeTierCurrentCount: '15 aktif ücretsiz katman 3B modelden {count} taneye sahipsiniz. Sınıra ulaştığınızda, 3B modelli yeni sayfalar yayınlayamazsınız. Aboneliğinizi yükseltmek için Müşteri Başarı Yöneticinizle iletişime geçin.',
    freeTierExceededError: 'Bu sayfanın 3B model ile yayınlanmasına izin verilmez.',
    freeTierExceededOption1: 'Aboneliğinizi yükseltmek için Müşteri Başarı Yöneticinizle iletişime geçin.',
    freeTierExceededOption2: 'Yayınlamak için 3B Modeli, sayfa taslağından kaldırın.',
    freeTierExceededTitle: 'Etkin 15 adet 3B model sınırını aştınız',
    illustrationLabel: '2B Görünüm',
    invalidFile: 'Karşıya yükleme için geçersiz dosya gönderildi',
    mapModelToBom: 'Modeli BOM ile Eşle',
    modelLabel: '3D Model',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: '3D Model Parça Numaralarıyla eşleşen BOM parçaları bulunamıyor',
    noPartsMatchRegEx: 'Düzenli ifadeyle eşleşen BOM parçası yok',
    orientation: 'Yön',
    orientationAndProjection: {
      back: 'Geri',
      bottom: 'Alt',
      front: 'Ön',
      isometric: 'İzometrik',
      left: 'Sol',
      orthographic: 'Ortografik',
      perspective: 'Perspektif',
      projection: 'Projeksiyon',
      right: 'Sağ',
      top: 'Üst'
    },
    partNumberProperty: 'Parça Numarası Özelliği',
    partNumberRegex: 'Parça Numarasına ait Düzenli İfade',
    partNumbersInModel: 'Modeldeki Parça Numaraları',
    resetCamera: 'Kamerayı Sıfırla',
    setAsDefaultView: 'Varsayılan Görünüm Olarak Ayarla',
    setAsDefaultViewTooltip: 'Bu yönü ve yakınlaştırma düzeyini varsayılan başlangıç görünümü olarak ayarlayın.',
    slice: {
      label: 'Dilim',
      planeX: 'Kesen Düzlem X',
      planeY: 'Kesen Düzlem Y',
      planeZ: 'Kesen Düzlem Z',
      reset: 'Kesen Düzlemi Sıfırla',
      section: 'Kesen Düzlem Bölümü Anahtarı',
      visibility: 'Kesme Düzlemi Görünürlüğü Anahtarı'
    },
    successfullyCreatedBomAssociations: '{count} 3d model BOM bileşenleri başarıyla oluşturuldu',
    successfullySavedDefaultView: 'Varsayılan görünüm başarıyla kaydedildi',
    supportedFilesMessage: 'Documoto, birçok CAD dosyası formatını desteklemektedir. CAD dosyası formatınızın desteklenip desteklenmediğinden emin değilseniz Destek Merkezi’ni kontrol edin.',
    threeD: '3D',
    toolsLabel: '3D Araçları',
    topAssemblyFilename: 'Üst Kurulum Dosya Adı',
    topAssemblyFilenameInvalid: 'Üst düzey derleme dosyası dosya listesinde yok',
    topAssemblyFilenameRequired: 'Üst Kurulum Dosya Adı gerekli',
    viewerControls: 'Görüntüleyici Kontrolleri',
    viewerSettings: '3D Görüntüleyici Ayarları',
    viewerTitle: '3D Görüntüleyici'
  },
  thu: 'Prş',
  thumbnail: 'Küçük Resim',
  thumbnailDeleted: 'Küçük Resim Başarıyla Silindi',
  thumbnailDeletedError: 'Küçük Resim Silinemedi',
  thumbnailReapplyWarning: 'Sistem, medyanın içeriğine bağlı olarak yeni bir küçük resim uygulayabilir. Bu işlem birkaç dakika alabilir.',
  thumbnailResizeTooltip: 'İşaretlendiği takdirde küçük resimleri 500x500 pikselden daha büyük olmayacak şekilde yeniden boyutlandırır',
  thumbnailUpdated: 'Küçük Resim Başarıyla Güncellendi',
  thumbnailUpdatedError: 'Küçük Resim Güncellemesi Başarısız Oldu',
  title: 'Başlık',
  to: 'Kime',
  toDate: 'Şimdiye Kadar',
  toGetStarted: 'E-posta Formatı Ekle.',
  toastNotifications: 'Toast Bildirimleri',
  toc: 'İçindekiler',
  tocClipBoardSuccessTitle: 'Panoya kopyalandı',
  tocClipBoardWarningText: 'UYARI: Kaydedilmemiş değişiklikler panonuza kopyalanamaz',
  tocClipBoardWarningTitle: 'Panoya kopyalandı',
  tocDisplayingFirstValues: 'İlk 100 değer görüntüleniyor. Daha fazlasını görüntülemek için filtreyi kullanın.',
  tocDuplicateWarningText: 'Bir bölümde yinelenen sayfa algılandı. Yinelenenler kaldırıldı.',
  tocEmptyMessage: 'Görünüşe göre henüz bir İçindekiler Tablosu oluşturmadınız.',
  tocMissingChapterName: 'Eksik Bölüm Adı',
  tocModalTableCaption: 'Etiket Düzenleyici Modeli',
  tocNothingSelected: 'Seçilen Öge Yok',
  tocOpenEditor: 'Düzenleyiciyi Aç',
  tocSaveRequired: 'Bölüm ayrıntılarını düzenlemeden önce kaydetmek gereklidir',
  tocState: 'İçindekiler Tablosunun Başlangıç Durumu',
  tocThumbnailDeleteFailTitle: 'Küçük Resim Silinemedi',
  tocThumbnailDeleteSuccessTitle: 'Küçük Resim Silme Başarılı',
  tocThumbnailUploadFailTitle: 'Küçük Resim Yüklenemedi',
  tocThumbnailUploadSuccessTitle: 'Küçük Resim Yükleme Başarılı',
  tocTranslationMessage: 'Bu bölümün adı ve isteğe bağlı açıklaması',
  tocUntitledPage: 'İsimsiz Sayfa',
  togglePage: 'Sayfayı Aç Kapat',
  tooManySelections: 'Liste {limit} seçim sınırını aşıyor',
  top: 'Üst',
  total: 'Toplam',
  totalItems: 'Toplam Öge',
  translation: 'Çeviri | Çeviriler',
  translationHelpTextItem: 'Bu {item} ögesinin adı ve isteğe bağlı açıklaması',
  'true': 'Doğru',
  tryAgain: 'Lütfen tekrar deneyin.',
  trySearchingToc: 'Gördüğünüz veya hatırladığınız herhangi bir sözcüğü aramayı deneyin. Liste anında daraltılır. Siz herhangi bir sonuca tıklayana kadar görünüm değişmez.',
  tryThis: 'Bunu Dene',
  tue: 'Sal',
  turkishDescription: 'Türkçe Açıklama',
  turkishName: 'Türkçe Ad',
  twoSided: '2 taraflı',
  type: 'Tür | Türler',
  typeAtLeastTwoChars: 'Eşleşme listesini görüntülemek için en az 2 karakter yazın.',
  typeSearchCriteriaAlreadySet: 'Değişiklikleri uygulamak için seçilen "Tür" arama kriterini silin.',
  typeToConfirm: 'Onaylamak için {value} yazın',
  typography: 'Tipografi',
  ukraineDescription: 'Ukraynaca Açıklama',
  ukraineName: 'Ukraynaca Ad',
  unableToRetrieveResults: 'Sorgunuza/aramanıza ilişkin sonuçlar alınamıyor',
  unauthorized: 'Yetkisiz',
  unknownError: 'Bilinmeyen hata, lütfen yardım için support{\'@\'}documoto.com adresinden Documoto destek merkezi ile iletişime geçin',
  unknownInput: 'Bilinmeyen inputType:',
  unknownPart: 'Bilinmeyen Parça',
  unknownType: 'Bilinmeyen Tür',
  unsavedAPIKeyWarning: 'Dönmezseniz Uygulama Programı Arabirimi Anahtarınız kaybolacak',
  unsavedChanges: 'Kaydedilmemiş değişiklikleriniz var. Devam edilsin mi?',
  unsavedChangesWarning: 'Kaydetmezseniz değişiklikleriniz kaybolacak.',
  unsavedWidgetKeyWarning: 'Geri dönmemeniz durumunda Widget Anahtarınız kaybolur.',
  unsupportedBrowserMessage: 'Bu uygulamayı en son teknoloji ile oluşturduk. Bu sayede uygulama hızlı ve kullanımı kolaydır. Üzgünüz, tarayıcınız bu teknolojileri desteklemiyor.',
  untitledOrg: 'Başlıksız Kuruluş',
  unverified: 'Doğrulanmamış',
  uom: 'Ölçü Birimi',
  update: 'Güncelle',
  updateFailed: 'Güncelleme başarısız',
  updateIndex: 'İndeksi Güncelle',
  updatePassword: 'Parolayı Güncelle',
  updatePasswordMessage: 'Parola başarılı şekilde güncellendi',
  updatePasswordPending: 'Parola değişikliği kaydedilmeyi bekliyor.',
  updated: 'Güncellendi',
  upgradeBrowser: 'Lütfen tarayıcınızı yenileyin.',
  upload: 'Yükle',
  uploadComplete: 'Yükleme Tamamlandı',
  uploadFileSizeLimitExceeded: 'Dosya, uygulama içi görüntüleme için belirlenen dosya boyutu sınırını aşıyor.',
  uploadInProgress: 'Yükleme Devam Ediyor',
  uponSavingDisabledTenant: 'Bu sayfa, bu ayar etkinleştirilmiş olarak kaydedildikten sonra şunlar olacaktır:',
  uponSavingThisLicense: 'Bu sayfa, bu ayarlarla kaydedildikten sonra ŞUNLARI YAPMANIZ GEREKMEKTEDİR:',
  upperBound: 'Üst Sınır',
  usCurrency: 'ABD Doları',
  useDefaultCartColumns: 'Varsayılan Sepet Sütunlarını Kullan',
  useDefaultPartsListColumns: 'Varsayılan Parça Listesi Sütunlarını Kullan',
  useSequentialPageNumbering: 'Sıralı Sayfa Numaralandırma Kullan',
  useSniForSsoMetadataRetrieval: 'SSO Meta Veri Alımı İçin SNI Kullan',
  user: 'Kullanıcı',
  userAddress: 'Kullanıcı Adresleri | Kullanıcı Adresleri',
  userCount: 'Kullanıcı Sayısı',
  userEditable: 'Kullanıcı Tarafından Düzenlenebilir',
  userExpirationDate: 'Kullanıcı Sona Erme Tarihi',
  userExpirationDateInvalid: 'Kullanıcı Sona Erme Tarihi Girilmeli',
  userGroup: 'Kullanıcı Grubu | Kullanıcı Grupları',
  userGroupEmpty: 'Kullanıcı Grupları boş olamaz',
  userGroupType: 'Kullanıcı Grubu Türü',
  userGroupUniqueMessage: 'Bu ad, bu kiracı için diğer tüm Kullanıcı Grubu adlarından farklı olmalıdır',
  userGroupUsers: 'Kullanıcı Grubu Kullanıcıları',
  userSettings: 'Kullanıcı Ayarları',
  userVerificationEmailBody: 'Kullanıcı Doğrulama E-Posta Gövdesi',
  userVerificationEmailFieldsValidation: 'Kullanıcı Doğrulama E-Postası alanlarının her ikisi de boş olmamalı veya her ikisi de boş olmalıdır',
  userVerificationEmailSubject: 'Kullanıcı Doğrulama E-Posta Konusu',
  username: 'Kullanıcı Adı',
  usernameEmpty: 'Kullanıcı adı boş olamaz',
  users: 'Kullanıcı',
  usersWillReceiveAnUnauthorizedError: 'Kullanıcılar, kiracıda oturum açmayı denediklerinde “Yetkisiz” hatası alacaktır.',
  validate: 'Doğrula',
  validateTenantDirectories: {
    buttonLabel: 'İçerik Dizinlerini Doğrula',
    error: 'Dizinler doğrulanamadı',
    success: 'Kiracı dizinleri doğrulandı'
  },
  validationMessage: 'Doğrulama Mesajı | Doğrulama Mesajları',
  value: 'Değer',
  valueGteError: 'Değer, en fazla {max} olmalıdır',
  valueLteError: 'Değer, en az {min} olmalıdır',
  variantSKU: 'Varyant Stok Tutma Birimi',
  vendorName: 'Satıcı Adı',
  verificationEmailRequested: 'Kaydettiğinizde doğrulama e-postası gönderilecektir.',
  verificationEmailSent: 'Doğrulama e-postası gönderildi.  Parola belirlenmemiş.',
  verified: 'Doğrulanmış',
  verifyPassword: 'Parolayı Doğrula',
  verifying: 'Doğrulanıyor',
  version: 'Versiyon',
  vertical: 'Dikey',
  video: 'Video | Videolar',
  view: 'Görünüm',
  viewAll: 'Tümünü Görüntüle',
  viewAllPagesAndBooks: 'Görüntüle: Tüm Sayfalar ve Kitaplar',
  viewAllResults: 'Tüm Sonuçları Görüntüle',
  viewBooks: 'Görüntüle: Kitaplar',
  viewModeList: 'Liste Görünümü',
  viewModeTable: 'Tablo Görünümü',
  viewMore: 'Daha Fazla Görüntüle',
  viewPages: 'Görüntüle: Sayfalar',
  viewWhereUsed: 'Kullanıldığı Yeri Görüntüle',
  views: 'Görüntülemeler',
  visibility: 'Görülebilirlik',
  visibilityDescription: 'Bu {entity} varlığını kim görüntüleyebilir',
  visible: 'Görülebilir',
  waitForUpload: 'Lütfen yüklemenin tamamlanmasını bekleyin.',
  watermark: 'Filigran',
  watermarkFont: 'Filigran Yazı Tipi',
  watermarkOpacityPercentage: 'Filigran Opaklığı %',
  watermarkOrientation: 'Filigran Yönü',
  watermarkSaveFailed: 'Filigran kaydedilemedi.',
  watermarkSaved: 'Filigran Kaydedildi',
  watermarkSelectionRequired: 'Kullanıcı adı veya Metin seçimi gerekli.',
  watermarkText: 'Filigran Metni',
  wed: 'Çrş',
  whereUsed: 'Kullanım Yeri',
  whereUsedCountInSearchBar: 'Arama Çubuğunda Kullanım Sayısı',
  whoCanViewComment: 'Bu yorumu kimler görüntüleyebilir?',
  wholesale: 'Toptan Satış',
  wholesalePrice: 'Toptan Satış Fiyatı',
  wholesaleTotal: 'Toptan Satış Toplamı',
  widget: 'Widget',
  widgetAuthHeader: 'Widget Yetki Değeri',
  widgetErrorConfig: 'Hatalı widget yapılandırması nedeniyle widget başlatılamadı',
  widgetErrorInit: 'Documoto Widget’ı başlatılamadı',
  widgetErrorLocation: 'Widget içinde belirtilen içerik bulunamadı',
  widgetErrorMultipleLocations: 'Belirtilen içerik için birden fazla konum bulundu',
  widgetKey: 'Widget Anahtarı | Widget Anahtarları',
  widgetKeyAdmin: 'Widget Anahtarı Yönetici',
  widgetKeyCopied: 'Widget Yetki değeri Panoya kopyalandı',
  widgetKeyDeleteMsg: 'Widget Anahtarı silme işlemi, kullanımını devre dışı bırakır',
  widgetKeyDeleted: 'Widget Anahtarı Silindi',
  widgetKeyDeletedError: 'Widget Anahtarı silinirken hata oluştu',
  widgetKeyManager: 'Widget Anahtarı Yöneticisi',
  widgetKeyNameEmpty: 'Ad gereklidir ve benzersiz olmalıdır. Bu değer, herhangi bir Widget etkinliği için kullanıcı adı olarak raporlama ve günlüğe kaydetme amacıyla da kullanılır.',
  widgetKeyRegenError: 'Widget Anahtarı yeniden oluşturulurken hata',
  widgetKeyRegenMsg: 'Bu Widget Anahtarını yeniden oluşturmak var olan birleşmeleri devre dışı bırakabilir',
  widgetKeyRegenTitle: 'Bu Widget Anahtarını yeniden oluşturmak istediğinize emin misiniz?',
  widgetKeySaved: 'Widget Anahtarı Kaydedildi',
  widgetPermissions: 'Widget kullanıcıları salt okunur biçimdedir ve özellik erişimi Widget seviyesi yapılandırması tarafından yönetilir. Standart kullanıcı grubu izinleri Widget kullanıcılarına uygulanmaz Ancak Medya Kategorisi erişim ayrıcalıklarına uygulanır. Lütfen medya kategorisi erişim kontrollerini atamaya devam edin.',
  widgetRefreshErrorMsg: 'Talep edilen içeriği görmek için lütfen sayfanızı yenileyin',
  widgetUserGroup: 'Widget Kullanıcı Grubu',
  widgetUserGroupDeleteMsg: 'Kullanıcıları olan Widget grubu silinemez',
  willBeAffected: 'etkilenecek.',
  willBeDeleted: '{content} silinecek.',
  willBeInsertedIntoItem: '{name}, {item} ögesi içine eklenecek',
  willBeUpdated: 'güncellenecek.',
  year: 'Yıl',
  yourEmailAddress: 'E-Posta Adresiniz',
  zipCode: 'Posta Kodu',
  zoomHotpointToCanvas: 'Hotpoint’i Tuval boyutuna Yakınlaştır',
  zoomIn: 'Yakınlaştır',
  zoomOut: 'Uzaklaştır'
};
/* eslint-enable max-len */
